webpackJsonp([1],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(353),
  /* scopeId */
  "data-v-6f7c4bed",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(358);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/404',
    name: '404',
    component: __webpack_require__(340)
  }, {
    path: '*',
    redirect: '404'
  }, {
    path: '/',
    name: 'Index',
    component: __webpack_require__(343)
  }, {
    path: '/no',
    name: 'IndexNorway',
    component: __webpack_require__(344)
  }, {
    path: '/se',
    name: 'IndexSweden',
    component: __webpack_require__(345)
  }, {
    path: '/fo',
    name: 'IndexFaroeIslands',
    component: __webpack_require__(341)
  }, {
    path: '/is',
    name: 'IndexIceland',
    component: __webpack_require__(342)
  }]
}));

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(384);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        texts: {
            danish: 'Kære kunde<br><br>Mange tak for din henvendelse til os. Vi har registreret den i vores system og vi vender tilbage til dig, så du skal ikke gøre mere.<br><br>I øjeblikket kan du desværre opleve lidt længere svartid men vi arbejder hårdt på at kunne nedbringe den.<br><br>Vi håber på din tålmodighed og glæder os til at kunne hjælpe dig.<br><br>Med venlig hilsen Quooker Aftersales.<br><br>',
            swedish: 'Tak. Vi har nu modtaget din henvendelse.<br><br>Du kan normalt forvente at høre fra os inden for 6-8 arbejdsdage.',
            norwegian: 'Takk. Vi har mottatt din henvendelse.<br><br>Den forventede svartid er 2-4 arbeidsdager.',
            icelandic: 'Takk. Við höfum fengið fyrirspurn þína.<br><br>Áætlaður svartími er 6-8 virkir dagar.'
        },
        form: {
            attachments: [],
            meta: {
                id: null
            },
            container: {
                serial: null
            },
            validatedContainer: null,
            validatedFaucet: null,
            cube: {
                own: null,
                serial: null
            },
            faucet: {
                type: null,
                surface: null,
                meta: null,
                serial: null
            },
            problem: {
                questions: [{
                    question: 'Kommer der vand ud af hanen?',
                    questionNO: 'Kommer det vann ut av kranen?',
                    questionIS: 'Kemur vatn úr blöndunartækinu?',
                    answer: null
                }, {
                    question: 'Er vandet kogende?',
                    questionNO: 'Er vannet kokende?',
                    questionIS: 'Er vatnið að sjóða?',
                    answer: null
                }, {
                    question: 'Blinker Quooker hanen?',
                    questionNO: 'Blinker Quooker-kranen?',
                    questionIS: 'Blikar Quooker blöndunartækið?',
                    answer: null,
                    extra: null
                }, {
                    question: 'Nulstilling af Quooker er forsøgt?',
                    questionNO: 'Quooker startet på nytt?',
                    questionIS: 'Quooker endurræstur?',
                    slug: 'restart',
                    answer: null,
                    extra: null
                }],
                description: null
            },
            warranty: {
                underWarranty: null,
                installationMonth: null,
                installationYear: null
            },
            contact: {
                company: null,
                name: null,
                firstname: null,
                lastname: null,
                email: null,
                phone: null,
                address: null,
                validatedAddress: null
            },
            terms: {
                accepted: false
            },
            default: {
                email: 'service@quooker.dk'
            }
        }
    },
    modules: {}
}));

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_promise_auto__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_jsonp__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sentry_browser__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sentry_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__sentry_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__deveodk_vue_toastr__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__deveodk_vue_error_tracker__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__deveodk_vue_error_tracker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__deveodk_vue_error_tracker__);











__WEBPACK_IMPORTED_MODULE_8_raven_js___default.a.addPlugin(__WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$raven = __WEBPACK_IMPORTED_MODULE_8_raven_js___default.a;


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_jsonp___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vuelidate___default.a);


__WEBPACK_IMPORTED_MODULE_13__sentry_browser__["init"]({
    dsn: 'https://5f4a4e70a88448978031dc5dd7c0ba17@o188955.ingest.sentry.io/1375158',
    integrations: [new __WEBPACK_IMPORTED_MODULE_13__sentry_browser__["Integrations"].Vue({ Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */] })]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = '';
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer 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';



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14__deveodk_vue_toastr___default.a, {
    defaultPosition: 'toast-bottom-right',
    defaultType: 'info',
    defaultTimeout: 5000
});


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16__deveodk_vue_error_tracker___default.a, {
    HttpDriver: __webpack_require__(205),
    NotificationDriver: __webpack_require__(206),
    ReportDriver: __webpack_require__(207),
    HttpErrorCodes: {
        401: {
            title: 'Ingen adgang',
            message: 'Du har ikke adgang til at se dette',
            type: 'error'
        },
        400: {
            title: 'Ukendt fejl',
            message: 'Noget gik galt',
            type: 'error'
        },

        500: {
            title: 'Server fejl',
            message: 'Åhh nej noget er gået galt',
            type: 'error'
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_moment___default.a);
__webpack_require__(36);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'layout': __webpack_require__(339)
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['intro', 'singleFileUploaded', 'multipleFilesUploaded', 'noFilesUploaded', 'addFilesButton', 'remove'],
    data: function data() {
        return {
            loading: false
        };
    },

    methods: {
        uploadFile: function uploadFile(file) {
            var _this = this;

            var attachments = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(file.target.files);

            attachments.forEach(function (attachment) {
                var formData = new FormData();

                var size = attachment.size / 1000000;
                if (size < 2000) {
                    _this.loading = true;
                    formData.append('attachment', attachment);
                    formData.append('casenumber', _this.$store.state.form.meta.id);
                    var postUrl = 'https://serviceformapi.qservice.shop/api/upload';
                    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(postUrl, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(function (response) {
                        var fileObject = {
                            name: attachment.name,
                            size: attachment.size,
                            path: response.data
                        };
                        _this.$store.state.form.attachments.push(fileObject);
                        _this.$refs.attachmentform.reset();
                        _this.loading = false;
                    }).catch(function (response) {
                        console.log(response);
                        _this.loading = false;
                        alert('File upload failed. Please check if file is damaged.');
                    });
                } else {
                    alert('File size cannot exceed 2 GB. Please compress the file before uploading or choose a different file.');
                }
            });
        },
        removeAttachment: function removeAttachment(index) {
            this.$store.state.form.attachments.splice(index, 1);
        }
    },
    filters: {
        tomb: function tomb(number) {
            if (number > 0) {
                var formattedNumber = (number / 1000000).toFixed(2);
                return formattedNumber + ' Mb';
            } else {
                return '';
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            isOnline: true
        };
    },
    created: function created() {
        this.updateStatus();
    },

    components: {
        'offline': __webpack_require__(338)
    },
    methods: {
        updateStatus: function updateStatus() {
            if (typeof window.navigator.onLine === 'undefined') {
                this.isOnline = true;
            } else {
                this.isOnline = window.navigator.onLine;
            }
            window.addEventListener('online', this.updateStatus);
            window.addEventListener('offline', this.updateStatus);
        },
        getTextFromSheets: function getTextFromSheets() {
            var _this = this;

            var url = 'https://spreadsheets.google.com/feeds/cells/1W2tundguiulkb0tRXqqzUcaQjkIJRnQ6-MlJglKxnFk/1/public/values?alt=json-in-script';
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
                var formattedText = response.data.replace('gdata.io.handleScriptLoaded(', '').slice(0, -2);
                var jsonText = JSON.parse(formattedText);
                if (jsonText) {
                    _this.$store.state.texts.danish = jsonText.feed.entry[1].content.$t;
                    _this.$store.state.texts.swedish = jsonText.feed.entry[3].content.$t;
                    _this.$store.state.texts.norwegian = jsonText.feed.entry[5].content.$t;
                }
            });
        }
    }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data', 'show']
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data', 'show']
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);











/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            faucetSerial: false,
            address: null,
            zipcode: null,
            city: null,
            loading: false,
            showSerialHelper: false,
            showTapSerialHelper: false,
            showCubeSerialHelper: false,
            showBlinkHelper: false,
            show4BlinkHelper: false,
            showRestartHelper: false,
            currentStep: 0,
            showCubeInfo: false,
            showNordicChooser: false,
            faucets: [{
                title: 'Front',
                type: 'front',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/front-2.png'
            }, {
                title: 'Fusion Round',
                type: 'fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Fusion_Round_krom-1.png'
            }, {
                title: 'Fusion Square',
                type: 'fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Fusion-Square-krom-kopi.png'
            }, {
                title: 'Nordic Round',
                type: 'nordic',
                description: 'Kogende vand',
                image: 'static/img/Nordic_round.png'
            }, {
                title: 'Nordic Square',
                type: 'nordic',
                description: 'Kogende vand',
                image: 'static/img/Nordic_square.png'
            }, {
                title: 'Flex',
                type: 'flex',
                description: 'Koldt, varmt og kogende vand med udtræk',
                image: 'static/img/flex.png'
            }, {
                title: 'Classic Fusion Round',
                type: 'cl-fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Classic_Fusion_Round_krom.png'
            }, {
                title: 'Classic Fusion Square',
                type: 'cl-fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Classic_Fusion_Square_krom.png'
            }, {
                title: 'Classic Nordic Round',
                type: 'cl-nordic',
                description: 'Kogende vand',
                image: 'static/img/Classic_Nordic_Round_krom.png'
            }, {
                title: 'Classic Nordic Square',
                type: 'cl-nordic',
                description: 'Kogende vand',
                image: 'static/img/Classic_Nordic_Square_krom.png'
            }, {
                title: 'Modern',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/modern.png'
            }, {
                title: 'Classic',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/classic.png'
            }, {
                title: 'Basic',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/Basic.png'
            }, {
                title: 'Design',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/design.png'
            }],
            surfaces: [{
                title: 'Krom',
                fits: 'flex,nordic,fusion,classic,cl-nordic,cl-fusion',
                image: 'static/img/overflade_krom-e1515075015591.png'
            }, {
                title: 'Børstet krom',
                fits: 'nordic,fusion,classic',
                image: 'static/img/borstet_krom-e1515075356409.png'
            }, {
                title: 'Rustfrit stål',
                fits: 'front,nordic,fusion,flex,cl-nordic,cl-fusion',
                image: 'static/img/rustfrit_staal-e1515074931468.png'
            }, {
                title: 'Black',
                fits: 'front,fusion,flex',
                image: 'static/img/sort-e1515075215324.png'
            }, {
                title: 'Messing',
                fits: 'nordic,fusion',
                image: 'static/img/messing-e1515075074718.png'
            }, {
                title: 'Bruneret messing',
                fits: 'nordic,fusion,cl-fusion',
                image: 'static/img/bruneret_messing-e1515075086176.png'
            }, {
                title: 'Guld',
                fits: 'fusion,classic',
                image: 'static/img/guld-1-e1515075138363.png'
            }, {
                title: 'Rustfrit stål-look',
                fits: 'classic',
                image: 'static/img/rustfrit_staal-e1515074931468.png'
            }, {
                title: 'Rose copper',
                fits: 'front,flex,fusion',
                image: 'static/img/rose-copper.png'
            }, {
                title: 'Gunmetal',
                fits: 'front,flex,fusion',
                image: 'static/img/gunmetal.png'
            }, {
                title: 'Ved ikke',
                fits: 'front,flex,nordic,fusion,classic,cl-fusion,cl-nordic',
                image: 'static/img/ved_ikke-e1515075230382.png'
            }],
            months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
            serials: [{ identifier: 'VC3', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: 3127770, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: 307235, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399002, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCD3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399003, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBF3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBD3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399006, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW4', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW5', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW6', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VC5', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' }, { identifier: 'VCD5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VC7', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' }, { identifier: 'VCD7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CC4', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 434060, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' }, { identifier: 'CP4', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 419403, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' }, { identifier: 'CCE4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' }, { identifier: 'CPE4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' }, { identifier: 'CCF4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 403873, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPF4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 404361, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCD4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPD4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCW4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CC5', name: 'COMBI 3.0', slug: 'combi-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' }, { identifier: 'CP5', name: 'COMBI+ 3.0', slug: 'combi-plus-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' }, { identifier: 'CCF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' }, { identifier: 'CPF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' }, { identifier: 'CPE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW6', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-vcd3-vcw3', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-vbd3-vbw3-vbw4', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RCE', name: 'Combi 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-ccd-cpd-ccw-cpw', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-vcd5-vcw5', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RVR', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: null, taps: 'classic' }, { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RZR', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: null, taps: 'classic' }, { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RZB', name: 'PRO7-VAQ B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RCR', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' }, { identifier: 'RCE', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RCB', name: 'COMBI 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RPR', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' }, { identifier: 'RPE', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RPB', name: 'COMBI+ 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_5__bugsnag_js___default.a.start({
            apiKey: 'fb2377299cc33e6414f0205412393375',
            plugins: [new __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue___default.a()]
        });
        var randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000);
        this.$store.state.form.meta.id = 'QSF-' + randomNumber;

        setInterval(function () {
            if (_this.currentStep === 1) {
                _this.validateSerial();
            }
        }, 500);
    },

    methods: {
        goToSwedishForm: function goToSwedishForm() {
            window.location = window.location + 'se';
        },
        setPixel: function setPixel(title) {
            window.fbq('trackCustom', title);
        },
        resetAddress: function resetAddress() {
            this.$store.state.form.contact.validatedAddress = null;
            this.$store.state.form.contact.address = null;
        },
        validateFaucet: function validateFaucet(faucet) {
            if (faucet.type === 'nordic') {
                this.showNordicChooser = true;
            } else {
                this.$store.state.form.faucet.meta = null;
            }
            this.$store.state.form.validatedFaucet = faucet;
        },
        chooseNordic: function chooseNordic(type) {
            this.$store.state.form.faucet.meta = type;
            this.showNordicChooser = false;
        },
        validateSerial: function validateSerial() {
            var _this2 = this;

            function compare(a, b) {
                if (a.identifier > b.identifier) {
                    return -1;
                }
                if (a.identifier < b.identifier) {
                    return 1;
                }
                return 0;
            }

            var input = this.$store.state.form.container.serial;
            if (input !== null) {
                input = input.toUpperCase();
            }

            this.serials.sort(compare);

            this.$store.state.form.validatedContainer = null;

            if (input !== null) {
                if (input.startsWith('Q')) {
                    this.faucetSerial = true;
                } else {
                    this.faucetSerial = false;
                }
                this.serials.every(function (serial) {
                    if (input.match('^' + serial.identifier)) {
                        _this2.$store.state.form.validatedContainer = serial;

                        return false;
                    }
                    return true;
                });
            }
        },
        submitForm: function submitForm() {
            var _this3 = this;

            if (this.$store.state.form.meta.id === null || this.$store.state.form.meta.id === '') {
                var randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000);
                this.$store.state.form.meta.id = 'QSF-' + randomNumber;
            }
            this.loading = true;

            var Email = { send: function send(a) {
                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (n, e) {
                        a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send";var t = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(a);Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) {
                            n(e);
                        });
                    });
                }, ajaxPost: function ajaxPost(e, n, t) {
                    var a = Email.createCORSRequest("POST", e);a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () {
                        var e = a.responseText;null != t && t(e);
                    }, a.send(n);
                }, ajax: function ajax(e, n) {
                    var t = Email.createCORSRequest("GET", e);t.onload = function () {
                        var e = t.responseText;null != n && n(e);
                    }, t.send();
                }, createCORSRequest: function createCORSRequest(e, n) {
                    var t = new XMLHttpRequest();return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest()).open(e, n) : t = null, t;
                } };


            var emailElement = document.getElementById('emailMockup').innerHTML;
            var quookerEmail = emailElement;
            var formData = new FormData();
            formData.append('email', this.$store.state.form.contact.email);
            formData.append('country', 'FO');
            formData.append('html', quookerEmail);
            formData.append('customer_name', this.$store.state.form.contact.firstname + ' ' + this.$store.state.form.contact.lastname);
            formData.append('form_meta_id', this.$store.state.form.meta.id);
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('https://serviceformapi.qservice.shop/api/submit-form', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                _this3.loading = false;
                _this3.currentStep = 8;
            }).catch(function (err) {
                console.log(err);
                alert('Der skete en fejl ved indsendelse af formularen. Prøv venligst igen eller kontakt os hvis problemet fortsætter.');
                _this3.loading = false;
            });
        }
    },
    computed: {
        showEmailChooser: function showEmailChooser() {
            var url = location.href;
            if (url.includes('localhost') || url.includes('test')) {
                return true;
            } else {
                return false;
            }
        },
        sortedFaucets: function sortedFaucets() {
            var _this4 = this;

            if (this.$store.state.form.validatedContainer !== null) {
                var arr = [];
                this.faucets.forEach(function (faucet) {
                    if (_this4.$store.state.form.validatedContainer.taps.includes(faucet.type)) {
                        arr.push(faucet);
                    }
                });
                return arr;
            }
        },
        sortedSurfaces: function sortedSurfaces() {
            var _this5 = this;

            if (this.$store.state.form.validatedFaucet !== null) {
                var arr = [];
                this.surfaces.forEach(function (surface) {
                    if (surface.fits.includes(_this5.$store.state.form.validatedFaucet.type)) {
                        arr.push(surface);
                    }
                });
                return arr;
            }
        },
        formattedEmailBody: function formattedEmailBody() {
            var body = {
                personalizations: [{
                    to: [{
                        email: 'nr@deveo.dk',
                        name: 'Nicolai Ramsby'
                    }],
                    subject: 'Hello, World!'
                }],
                content: [{
                    type: 'text/plain',
                    value: 'Heya!'
                }],
                from: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                },
                reply_to: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                }
            };
            return body;
        },
        years: function years() {
            var currentYear = new Date().getFullYear();
            var years = [];
            var startYear = 2004;

            while (startYear <= currentYear) {
                years.push(startYear++);
            }

            return years;
        },
        fullAddress: function fullAddress() {
            return this.address + ', ' + this.zipcode + ' ' + this.city;
        }
    },
    components: {
        ValidationMessages: __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages___default.a,
        FileUpload: __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload___default.a
    },
    validations: {
        address: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        zipcode: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        city: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        $store: {
            state: {
                form: {
                    problem: {
                        description: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(20),
                            maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(1000)
                        }
                    },
                    contact: {
                        firstname: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
                        },
                        lastname: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
                        },
                        email: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
                        },
                        phone: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
                        }
                    }
                }
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessagesNO__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessagesNO___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessagesNO__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);











/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            faucetSerial: false,
            address: null,
            zipcode: null,
            city: null,
            loading: false,
            showSerialHelper: false,
            showTapSerialHelper: false,
            showCubeSerialHelper: false,
            showBlinkHelper: false,
            show4BlinkHelper: false,
            showRestartHelper: false,
            currentStep: 0,
            showNordicChooser: false,
            defaultToEmail: 'service@quooker.no',
            faucets: [{
                title: 'Front',
                type: 'front',
                description: 'Kalt, heitt og sjóðandi vatn',
                image: 'static/img/front-2.png'
            }, {
                title: 'Fusion Round',
                type: 'fusion',
                description: 'Kalt, heitt og sjóðandi vatn',
                image: 'static/img/Fusion_Round_krom-1.png'
            }, {
                title: 'Fusion Square',
                type: 'fusion',
                description: 'Kalt, heitt og sjóðandi vatn',
                image: 'static/img/Fusion-Square-krom-kopi.png'
            }, {
                title: 'Nordic Round',
                type: 'nordic',
                description: 'Sjóðandi vatn',
                image: 'static/img/Nordic_round.png'
            }, {
                title: 'Nordic Square',
                type: 'nordic',
                description: 'Sjóðandi vatn',
                image: 'static/img/Nordic_square.png'
            }, {
                title: 'Flex',
                type: 'flex',
                description: 'Kalt, heitt og sjóðandi vatn og útsogsslanga',
                image: 'static/img/flex.png'
            }, {
                title: 'Classic Fusion Round',
                type: 'cl-fusion',
                description: 'Kalt, heitt og sjóðandi vatn',
                image: 'static/img/Classic_Fusion_Round_krom.png'
            }, {
                title: 'Classic Fusion Square',
                type: 'cl-fusion',
                description: 'Kalt, heitt og sjóðandi vatn',
                image: 'static/img/Classic_Fusion_Square_krom.png'
            }, {
                title: 'Classic Nordic Round',
                type: 'cl-nordic',
                description: 'Sjóðandi vatn',
                image: 'static/img/Classic_Nordic_Round_krom.png'
            }, {
                title: 'Classic Nordic Square',
                type: 'cl-nordic',
                description: 'Sjóðandi vatn',
                image: 'static/img/Classic_Nordic_Square_krom.png'
            }, {
                title: 'Modern',
                type: 'classic',
                description: 'Sjóðandi vatn',
                image: 'static/img/modern.png'
            }, {
                title: 'Classic',
                type: 'classic',
                description: 'Sjóðandi vatn',
                image: 'static/img/classic.png'
            }, {
                title: 'Basic',
                type: 'classic',
                description: 'Sjóðandi vatn',
                image: 'static/img/Basic.png'
            }, {
                title: 'Design',
                type: 'classic',
                description: 'Sjóðandi vatn',
                image: 'static/img/design.png'
            }],
            surfaces: [{
                title: 'Króm',
                fits: 'flex,nordic,fusion,classic,cl-fusion,cl-nordic',
                image: 'static/img/overflade_krom-e1515075015591.png'
            }, {
                title: 'Burstað króm',
                fits: 'nordic,fusion,classic',
                image: 'static/img/borstet_krom-e1515075356409.png'
            }, {
                title: 'Ryðfrítt stál',
                fits: 'front,nordic,fusion,flex,cl-fusion,cl-nordic',
                image: 'static/img/rustfrit_staal-e1515074931468.png'
            }, {
                title: 'Black',
                fits: 'front,fusion,flex',
                image: 'static/img/sort-e1515075215324.png'
            }, {
                title: 'Brass',
                fits: 'nordic,fusion',
                image: 'static/img/messing-e1515075074718.png'
            }, {
                title: 'Aldraður kopar',
                fits: 'nordic,fusion,cl-fusion',
                image: 'static/img/bruneret_messing-e1515075086176.png'
            }, {
                title: 'Gull',
                fits: 'fusion,classic',
                image: 'static/img/guld-1-e1515075138363.png'
            }, {
                title: 'Ryðfrítt stál útlit',
                fits: 'classic',
                image: 'static/img/rustfrit_staal-e1515074931468.png'
            }, {
                title: 'Rose copper',
                fits: 'front,flex,fusion',
                image: 'static/img/rose-copper.png'
            }, {
                title: 'Gunmetal',
                fits: 'front,flex,fusion',
                image: 'static/img/gunmetal.png'
            }, {
                title: 'Veit ekki',
                fits: 'front,flex,nordic,fusion,classic,cl-fusion,cl-nordic',
                image: 'static/img/ved_ikke-e1515075230382.png'
            }],
            months: ['Janúar', 'Febrúar', 'Mars', 'Apríl', 'Maí', 'Júní', 'Júlí', 'Agúst', 'September', 'Október', 'Nóvember', 'Desember'],
            serials: [{ identifier: 'VC3', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: 3127770, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: 307235, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399002, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCD3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399003, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBF3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBD3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399006, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW4', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW5', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW6', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VC5', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' }, { identifier: 'VCD5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VC7', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' }, { identifier: 'VCD7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CC4', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 434060, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' }, { identifier: 'CP4', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 419403, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' }, { identifier: 'CCE4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' }, { identifier: 'CPE4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' }, { identifier: 'CCF4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 403873, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPF4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 404361, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCD4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPD4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCW4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CC5', name: 'COMBI 3.0', slug: 'combi-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' }, { identifier: 'CP5', name: 'COMBI+ 3.0', slug: 'combi-plus-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' }, { identifier: 'CCF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' }, { identifier: 'CPF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' }, { identifier: 'CPE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW6', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-vcd3-vcw3', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-vbd3-vbw3-vbw4', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RCE', name: 'Combi 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-ccd-cpd-ccw-cpw', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-vcd5-vcw5', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RVR', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: null, taps: 'classic' }, { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RZR', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: null, taps: 'classic' }, { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RZB', name: 'PRO7-VAQ B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RCR', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' }, { identifier: 'RCE', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RCB', name: 'COMBI 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RPR', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' }, { identifier: 'RPE', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RPB', name: 'COMBI+ 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_5__bugsnag_js___default.a.start({
            apiKey: 'fb2377299cc33e6414f0205412393375',
            plugins: [new __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue___default.a()]
        });
        this.$store.state.form.cube.own = false;

        var randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000);
        this.$store.state.form.meta.id = 'QSF-' + randomNumber;
        this.$store.state.form.cube.own = false;
        setInterval(function () {
            if (_this.currentStep === 1) {
                _this.validateSerial();
            }
        }, 500);
    },

    methods: {
        resetAddress: function resetAddress() {
            this.$store.state.form.contact.validatedAddress = null;
            this.$store.state.form.contact.address = null;
        },
        validateFaucet: function validateFaucet(faucet) {
            if (faucet.type === 'nordic') {
                this.showNordicChooser = true;
            } else {
                this.$store.state.form.faucet.meta = null;
            }
            this.$store.state.form.validatedFaucet = faucet;
        },
        chooseNordic: function chooseNordic(type) {
            this.$store.state.form.faucet.meta = type;
            this.showNordicChooser = false;
        },
        validateSerial: function validateSerial() {
            var _this2 = this;

            function compare(a, b) {
                if (a.identifier > b.identifier) {
                    return -1;
                }
                if (a.identifier < b.identifier) {
                    return 1;
                }
                return 0;
            }

            var input = this.$store.state.form.container.serial;
            if (input !== null) {
                input = input.toUpperCase();
            }

            this.serials.sort(compare);

            this.$store.state.form.validatedContainer = null;

            if (input !== null) {
                if (input.startsWith('Q')) {
                    this.faucetSerial = true;
                } else {
                    this.faucetSerial = false;
                }
                this.serials.every(function (serial) {
                    if (input.match('^' + serial.identifier)) {
                        _this2.$store.state.form.validatedContainer = serial;

                        return false;
                    }
                    return true;
                });
            }
        },
        submitForm: function submitForm() {
            var _this3 = this;

            if (this.$store.state.form.meta.id === null || this.$store.state.form.meta.id === '') {
                var randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000);
                this.$store.state.form.meta.id = 'QSF-' + randomNumber;
            }
            this.loading = true;

            var Email = { send: function send(a) {
                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (n, e) {
                        a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send";var t = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(a);Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) {
                            n(e);
                        });
                    });
                }, ajaxPost: function ajaxPost(e, n, t) {
                    var a = Email.createCORSRequest("POST", e);a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () {
                        var e = a.responseText;null != t && t(e);
                    }, a.send(n);
                }, ajax: function ajax(e, n) {
                    var t = Email.createCORSRequest("GET", e);t.onload = function () {
                        var e = t.responseText;null != n && n(e);
                    }, t.send();
                }, createCORSRequest: function createCORSRequest(e, n) {
                    var t = new XMLHttpRequest();return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest()).open(e, n) : t = null, t;
                } };


            var emailElement = document.getElementById('emailMockup').innerHTML;
            var quookerEmail = emailElement;

            var formData = new FormData();
            formData.append('email', this.$store.state.form.contact.email);
            formData.append('country', 'IS');
            formData.append('html', quookerEmail);
            formData.append('customer_name', this.$store.state.form.contact.firstname + ' ' + this.$store.state.form.contact.lastname);
            formData.append('form_meta_id', this.$store.state.form.meta.id);
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('https://serviceformapi.qservice.shop/api/submit-form', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                _this3.loading = false;
                _this3.currentStep = 8;
            }).catch(function (err) {
                console.log(err);
                alert('Villa kom upp við að senda eyðublaðið. Vinsamlegast reyndu aftur eða hafðu samband við okkur ef vandamálið er viðvarandi.');
                _this3.loading = false;
            });
        }
    },
    computed: {
        showEmailChooser: function showEmailChooser() {
            var url = location.href;
            if (url.includes('localhost') || url.includes('test')) {
                return true;
            } else {
                return false;
            }
        },
        sortedFaucets: function sortedFaucets() {
            var _this4 = this;

            if (this.$store.state.form.validatedContainer !== null) {
                var arr = [];
                this.faucets.forEach(function (faucet) {
                    if (_this4.$store.state.form.validatedContainer.taps.includes(faucet.type)) {
                        arr.push(faucet);
                    }
                });
                return arr;
            }
        },
        sortedSurfaces: function sortedSurfaces() {
            var _this5 = this;

            if (this.$store.state.form.validatedFaucet !== null) {
                var arr = [];
                this.surfaces.forEach(function (surface) {
                    if (surface.fits.includes(_this5.$store.state.form.validatedFaucet.type)) {
                        arr.push(surface);
                    }
                });
                return arr;
            }
        },
        formattedEmailBody: function formattedEmailBody() {
            var body = {
                personalizations: [{
                    to: [{
                        email: 'nr@deveo.dk',
                        name: 'Nicolai Ramsby'
                    }],
                    subject: 'Hello, World!'
                }],
                content: [{
                    type: 'text/plain',
                    value: 'Heya!'
                }],
                from: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                },
                reply_to: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                }
            };
            return body;
        },
        years: function years() {
            var currentYear = new Date().getFullYear();
            var years = [];
            var startYear = 2004;

            while (startYear <= currentYear) {
                years.push(startYear++);
            }

            return years;
        },
        fullAddress: function fullAddress() {
            return this.address + ', ' + this.zipcode + ' ' + this.city;
        }
    },
    components: {
        ValidationMessages: __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessagesNO___default.a,
        FileUpload: __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload___default.a
    },
    validations: {
        address: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        zipcode: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        city: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        $store: {
            state: {
                form: {
                    problem: {
                        description: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(20),
                            maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(1000)
                        }
                    },
                    contact: {
                        firstname: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
                        },
                        lastname: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
                        },
                        email: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
                        },
                        phone: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
                        }
                    }
                }
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);











/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            faucetSerial: false,
            addressIssues: false,
            loading: false,
            showSerialHelper: false,
            showTapSerialHelper: false,
            showCubeSerialHelper: false,
            showBlinkHelper: false,
            show4BlinkHelper: false,
            showRestartHelper: false,
            currentStep: 0,
            showCubeInfo: false,
            showNordicChooser: false,
            showAddressModal: false,
            showEContainerModal: false,
            showCubeErrorcodesModal: false,
            cubeErrorPage: 1,
            selectedCubeErrorcode: null,
            cubeErrorcodes: [{
                code: 'E1',
                title: 'Ventilator defekt / ventilator sidder fast / ventilator ikke tilsluttet',
                description: 'Ventilatoren virker ikke',
                solution: 'Prøv at rengøre ventilatoren med en børste eller støvsuger. Hvis problemet fortsætter, skal du blot gå videre.',
                icon: false
            }, {
                code: 'E2',
                title: 'Utilstrækkelig kølemiddel / forkert placering af temperatursensor',
                description: 'Utilstrækkelig køling',
                solution: 'Tryk på genstartsikonet på displayet. Hvis problemet fortsætter, skal du blot gå videre.',
                icon: true
            }, {
                code: 'E3',
                title: 'Pumpen virker ikke; ingen vandforsyning / for meget luft i systemet / højdesensor ikke tilsluttet',
                description: 'Beholderen med vand med brus er ikke fyldt op',
                solution: 'Kontrollér, om afspærringsventilen er åben (kontraintuitivt). Tjek, at slangerne ikke er bukkede. Tryk på genstartsikonet på displayet. Hvis problemet fortsætter, skal du blot gå videre.',
                icon: true
            }, {
                code: 'E4',
                title: 'Lækage eller kondens',
                description: 'For meget vand i drypbakken',
                solution: 'Kontakt os ved at gå videre i denne formular.',
                icon: false
            }, {
                code: 'E9',
                title: 'Vandforsyningen er ikke tilsluttet under opstartsprocessen',
                description: 'Pumpens hastighed er for høj under opstartsprocessen',
                solution: 'Kontrollér, om afspærringsventilen er åben (kontraintuitivt). Tjek, at slangerne ikke er bukkede. Hvis problemet fortsætter, skal du blot gå videre.',
                icon: false
            }],
            faucets: [{
                title: 'Front',
                type: 'front',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/front-2.png'
            }, {
                title: 'Fusion Round',
                type: 'fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Fusion_Round_krom-1.png'
            }, {
                title: 'Fusion Square',
                type: 'fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Fusion-Square-krom-kopi.png'
            }, {
                title: 'Nordic Round',
                type: 'nordic',
                description: 'Kogende vand',
                image: 'static/img/Nordic_round.png'
            }, {
                title: 'Nordic Square',
                type: 'nordic',
                description: 'Kogende vand',
                image: 'static/img/Nordic_square.png'
            }, {
                title: 'Flex',
                type: 'flex',
                description: 'Koldt, varmt og kogende vand med udtræk',
                image: 'static/img/flex.png'
            }, {
                title: 'Classic Fusion Round',
                type: 'cl-fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Classic_Fusion_Round_krom.png'
            }, {
                title: 'Classic Fusion Square',
                type: 'cl-fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Classic_Fusion_Square_krom.png'
            }, {
                title: 'Classic Nordic Round',
                type: 'cl-nordic',
                description: 'Kogende vand',
                image: 'static/img/Classic_Nordic_Round_krom.png'
            }, {
                title: 'Classic Nordic Square',
                type: 'cl-nordic',
                description: 'Kogende vand',
                image: 'static/img/Classic_Nordic_Square_krom.png'
            }, {
                title: 'Modern',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/modern.png'
            }, {
                title: 'Classic',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/classic.png'
            }, {
                title: 'Basic',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/Basic.png'
            }, {
                title: 'Design',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/design.png'
            }],
            surfaces: [{
                title: 'Krom',
                fits: 'flex,nordic,fusion,classic,cl-nordic,cl-fusion',
                image: 'static/img/overflade_krom-e1515075015591.png'
            }, {
                title: 'Børstet krom',
                fits: 'nordic,fusion,classic',
                image: 'static/img/borstet_krom-e1515075356409.png'
            }, {
                title: 'Rustfrit stål',
                fits: 'front,nordic,fusion,flex,cl-nordic,cl-fusion',
                image: 'static/img/rustfrit_staal-e1515074931468.png'
            }, {
                title: 'Black',
                fits: 'front,fusion,flex',
                image: 'static/img/sort-e1515075215324.png'
            }, {
                title: 'Messing',
                fits: 'nordic,fusion',
                image: 'static/img/messing-e1515075074718.png'
            }, {
                title: 'Bruneret messing',
                fits: 'nordic,fusion,cl-fusion',
                image: 'static/img/bruneret_messing-e1515075086176.png'
            }, {
                title: 'Guld',
                fits: 'fusion,classic',
                image: 'static/img/guld-1-e1515075138363.png'
            }, {
                title: 'Rustfrit stål-look',
                fits: 'classic',
                image: 'static/img/rustfrit_staal-e1515074931468.png'
            }, {
                title: 'Rose copper',
                fits: 'front,flex,fusion',
                image: 'static/img/rose-copper.png'
            }, {
                title: 'Gunmetal',
                fits: 'front,flex,fusion',
                image: 'static/img/gunmetal.png'
            }, {
                title: 'Ved ikke',
                fits: 'front,flex,nordic,fusion,classic,cl-fusion,cl-nordic',
                image: 'static/img/ved_ikke-e1515075230382.png'
            }],
            months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
            serials: [{ identifier: 'VC3', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: 3127770, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: 307235, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399002, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCD3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399003, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBF3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBD3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399006, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW4', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW5', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW6', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VC5', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' }, { identifier: 'VCD5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VC7', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' }, { identifier: 'VCD7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CC4', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 434060, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' }, { identifier: 'CP4', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 419403, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' }, { identifier: 'CCE4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' }, { identifier: 'CPE4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' }, { identifier: 'CCF4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 403873, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPF4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 404361, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCD4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPD4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCW4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CC5', name: 'COMBI 3.0', slug: 'combi-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' }, { identifier: 'CP5', name: 'COMBI+ 3.0', slug: 'combi-plus-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' }, { identifier: 'CCF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' }, { identifier: 'CPF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' }, { identifier: 'CPE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW6', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-vcd3-vcw3', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-vbd3-vbw3-vbw4', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RCE', name: 'Combi 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-ccd-cpd-ccw-cpw', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-vcd5-vcw5', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RVR', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: null, taps: 'classic' }, { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RZR', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: null, taps: 'classic' }, { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RZB', name: 'PRO7-VAQ B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RCR', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' }, { identifier: 'RCE', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RCB', name: 'COMBI 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RPR', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' }, { identifier: 'RPE', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RPB', name: 'COMBI+ 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }]
        };
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_5__bugsnag_js___default.a.start({
            apiKey: 'fb2377299cc33e6414f0205412393375',
            plugins: [new __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue___default.a()]
        });
        var randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000);
        this.$store.state.form.meta.id = 'QSF-' + randomNumber;
        var inputElm = document.getElementById('dawa-autocomplete-input');
        var self = this;
        try {
            window.dawaAutocomplete.dawaAutocomplete(inputElm, {
                select: function select(selected) {
                    console.log(selected);
                    self.$store.state.form.contact.validatedAddress = selected.tekst;
                    self.$store.state.form.contact.address = selected.tekst;
                }
            });
        } catch (err) {
            alert('ADVARSEL! Det ser ud til at du benytter en ældre browser. Vores formularer supporterer desværre ikke ældre browsere. Vi anbefaler, at du benytter en nyere version af Google Chrome eller Firefox for at benytte formularen. Kontakt os på service@quooker.dk for at få yderligere hjælp.');
        }
    },

    methods: {
        goToSwedishForm: function goToSwedishForm() {
            window.location = window.location + 'se';
        },
        goToFaroeIslandsForm: function goToFaroeIslandsForm() {
            window.location = window.location + 'fo';
        },
        setPixel: function setPixel(title) {
            window.fbq('trackCustom', title);
        },
        resetAddress: function resetAddress() {
            this.$store.state.form.contact.validatedAddress = null;
            this.$store.state.form.contact.address = null;
        },
        validateFaucet: function validateFaucet(faucet) {
            if (faucet.type === 'nordic') {
                this.showNordicChooser = true;
            } else {
                this.$store.state.form.faucet.meta = null;
            }
            this.$store.state.form.validatedFaucet = faucet;
        },
        chooseNordic: function chooseNordic(type) {
            this.$store.state.form.faucet.meta = type;
            this.showNordicChooser = false;
        },
        validateSerial: function validateSerial() {
            var _this = this;

            function compare(a, b) {
                if (a.identifier > b.identifier) {
                    return -1;
                }
                if (a.identifier < b.identifier) {
                    return 1;
                }
                return 0;
            }

            var input = this.$store.state.form.container.serial;
            if (input !== null) {
                input = input.toUpperCase();
            }

            this.serials.sort(compare);

            this.$store.state.form.validatedContainer = null;

            if (input !== null) {
                if (input.startsWith('Q')) {
                    this.faucetSerial = true;
                } else {
                    this.faucetSerial = false;
                }

                var eIdentifiers = ['VC3', 'VC5', 'VC7', 'CC4', 'CC5', 'CC7', 'CP4', 'CP5', 'CP7'];
                eIdentifiers.forEach(function (identifier) {
                    var match = identifier === input.toUpperCase();
                    if (match) {
                        _this.showEContainerModal = true;
                        return;
                    }
                });

                this.serials.every(function (serial) {
                    if (input.match('^' + serial.identifier)) {
                        _this.$store.state.form.validatedContainer = serial;

                        return false;
                    }
                    return true;
                });
            }
        },
        submitForm: function submitForm() {
            var _this2 = this;

            if (this.$store.state.form.contact.validatedAddress === null || this.$store.state.form.contact.validatedAddress === undefined || this.$store.state.form.contact.validatedAddress === '') {
                this.addressValidationError();
                return;
            }
            if (this.$store.state.form.meta.id === null || this.$store.state.form.meta.id === '') {
                var randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000);
                this.$store.state.form.meta.id = 'QSF-' + randomNumber;
            }
            this.loading = true;

            var Email = { send: function send(a) {
                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (n, e) {
                        a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send";var t = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(a);Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) {
                            n(e);
                        });
                    });
                }, ajaxPost: function ajaxPost(e, n, t) {
                    var a = Email.createCORSRequest("POST", e);a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () {
                        var e = a.responseText;null != t && t(e);
                    }, a.send(n);
                }, ajax: function ajax(e, n) {
                    var t = Email.createCORSRequest("GET", e);t.onload = function () {
                        var e = t.responseText;null != n && n(e);
                    }, t.send();
                }, createCORSRequest: function createCORSRequest(e, n) {
                    var t = new XMLHttpRequest();return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest()).open(e, n) : t = null, t;
                } };


            var emailElement = document.getElementById('emailMockup').innerHTML;
            var quookerEmail = emailElement;

            var formData = new FormData();
            formData.append('email', this.$store.state.form.contact.email);
            formData.append('country', 'DK');
            formData.append('html', quookerEmail);
            formData.append('customer_name', this.$store.state.form.contact.firstname + ' ' + this.$store.state.form.contact.lastname);
            formData.append('form_meta_id', this.$store.state.form.meta.id);
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('https://serviceformapi.qservice.shop/api/submit-form', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                _this2.loading = false;
                _this2.currentStep = 8;
            }).catch(function (err) {
                console.log(err);
                alert('Der skete en fejl ved indsendelse af formularen. Prøv venligst igen eller kontakt os hvis problemet fortsætter.');
                _this2.loading = false;
            });
        },
        addressValidationError: function addressValidationError() {
            this.addressIssues = true;
            this.showAddressModal = true;
        },
        submitManualAddress: function submitManualAddress() {
            var _this3 = this;

            this.$store.state.form.contact.validatedAddress = this.$store.state.form.contact.address;
            this.showAddressModal = false;
            setTimeout(function () {
                _this3.submitForm();
            }, 1000);
        }
    },
    computed: {
        showEmailChooser: function showEmailChooser() {
            var url = location.href;
            if (url.includes('localhost') || url.includes('test')) {
                return true;
            } else {
                return false;
            }
        },
        sortedFaucets: function sortedFaucets() {
            var _this4 = this;

            if (this.$store.state.form.validatedContainer !== null) {
                var arr = [];
                this.faucets.forEach(function (faucet) {
                    if (_this4.$store.state.form.validatedContainer.taps.includes(faucet.type)) {
                        arr.push(faucet);
                    }
                });
                return arr;
            }
        },
        sortedSurfaces: function sortedSurfaces() {
            var _this5 = this;

            if (this.$store.state.form.validatedFaucet !== null) {
                var arr = [];
                this.surfaces.forEach(function (surface) {
                    if (surface.fits.includes(_this5.$store.state.form.validatedFaucet.type)) {
                        arr.push(surface);
                    }
                });
                return arr;
            }
        },
        formattedEmailBody: function formattedEmailBody() {
            var body = {
                personalizations: [{
                    to: [{
                        email: 'nr@deveo.dk',
                        name: 'Nicolai Ramsby'
                    }],
                    subject: 'Hello, World!'
                }],
                content: [{
                    type: 'text/plain',
                    value: 'Heya!'
                }],
                from: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                },
                reply_to: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                }
            };
            return body;
        },
        years: function years() {
            var currentYear = new Date().getFullYear();
            var years = [];
            var startYear = 2004;

            while (startYear <= currentYear) {
                years.push(startYear++);
            }

            return years;
        }
    },
    components: {
        ValidationMessages: __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages___default.a,
        FileUpload: __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload___default.a
    },
    validations: {
        $store: {
            state: {
                form: {
                    problem: {
                        description: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(20),
                            maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(1000)
                        }
                    },
                    contact: {
                        firstname: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
                        },
                        lastname: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
                        },
                        email: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
                        },
                        phone: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
                        }
                    }
                }
            }
        }
    },
    watch: {
        '$store.state.form.container.serial': 'validateSerial'
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(354),
  /* scopeId */
  "data-v-7bc6810e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessagesNO__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessagesNO___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessagesNO__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);











/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showDanishAlert: false,
            faucetSerial: false,
            address: null,
            zipcode: null,
            city: null,
            loading: false,
            showSerialHelper: false,
            showTapSerialHelper: false,
            showCubeSerialHelper: false,
            showBlinkHelper: false,
            show4BlinkHelper: false,
            showRestartHelper: false,
            currentStep: 0,
            showNordicChooser: false,
            showCubeErrorcodesModal: false,
            cubeErrorPage: 1,
            selectedCubeErrorcode: null,
            cubeErrorcodes: [{
                code: 'E1',
                title: 'Ventilator defekt/ventilator sitter fast/ventilator ikke tilkoblet',
                description: 'Ventilatoren virker ikke',
                solution: 'Prøv å rengjøre ventilatoren med en børste eller støvsuger. Hvis problemet vedvarer, bare gå videre.',
                icon: false
            }, {
                code: 'E2',
                title: 'Utilstrekkelig kjølemiddel / feil plassering av temperatursensor',
                description: 'Utilstrekkelig kjøling',
                solution: 'Trykk på gjenstartsikonet på displayet. Hvis problemet vedvarer, bare gå videre.',
                icon: true
            }, {
                code: 'E3',
                title: 'Pumpen virker ikke; ingen vannforsyning / for mye luft i systemet / høydesensor ikke tilkoblet',
                description: 'Beholderen med kullsyrevann er ikke fyllt opp',
                solution: 'Kontrollér at avsperringsventilen er åpen (kontraintuitivt). Undersøk at slangene ikke er bøyde. Trykk på gjenstartsikonet på displayet. Hvis problemet vedvarer, bare gå videre.',
                icon: true
            }, {
                code: 'E4',
                title: 'Lekkasje eller kondens',
                description: 'For mye vann i dryppbrett',
                solution: 'Kontakt oss ved å fylle ut dette skjemaet.',
                icon: false
            }, {
                code: 'E9',
                title: 'Vannforsyningen er ikke tilkoblet under oppstartsprosessen',
                description: 'Pumpens hastighet er for høy under oppstartsprosessen',
                solution: 'Kontrollér at avsperringsventilen er åpen (kontraintuitivt). Undersøk at slangene ikke er bøyde. Hvis problemet vedvarer, bare gå videre.',
                icon: false
            }],
            defaultToEmail: 'service@quooker.no',
            faucets: [{
                title: 'Front',
                type: 'front',
                description: 'Kaldt, varmt og kokende vann',
                image: 'static/img/front-2.png'
            }, {
                title: 'Fusion Round',
                type: 'fusion',
                description: 'Kaldt, varmt og kokende vann',
                image: 'static/img/Fusion_Round_krom-1.png'
            }, {
                title: 'Fusion Square',
                type: 'fusion',
                description: 'Kaldt, varmt og kokende vann',
                image: 'static/img/Fusion-Square-krom-kopi.png'
            }, {
                title: 'Nordic Round',
                type: 'nordic',
                description: 'Kokende vann',
                image: 'static/img/Nordic_round.png'
            }, {
                title: 'Nordic Square',
                type: 'nordic',
                description: 'Kokende vann',
                image: 'static/img/Nordic_square.png'
            }, {
                title: 'Flex',
                type: 'flex',
                description: 'Kaldt, varmt og kokende vann og uttrekksslange',
                image: 'static/img/flex.png'
            }, {
                title: 'Classic Fusion Round',
                type: 'cl-fusion',
                description: 'Kaldt, varmt og kokende vann',
                image: 'static/img/Classic_Fusion_Round_krom.png'
            }, {
                title: 'Classic Fusion Square',
                type: 'cl-fusion',
                description: 'Kaldt, varmt og kokende vann',
                image: 'static/img/Classic_Fusion_Square_krom.png'
            }, {
                title: 'Classic Nordic Round',
                type: 'cl-nordic',
                description: 'Kokende vann',
                image: 'static/img/Classic_Nordic_Round_krom.png'
            }, {
                title: 'Classic Nordic Square',
                type: 'cl-nordic',
                description: 'Kokende vann',
                image: 'static/img/Classic_Nordic_Square_krom.png'
            }, {
                title: 'Modern',
                type: 'classic',
                description: 'Kokende vann',
                image: 'static/img/modern.png'
            }, {
                title: 'Classic',
                type: 'classic',
                description: 'Kokende vann',
                image: 'static/img/classic.png'
            }, {
                title: 'Basic',
                type: 'classic',
                description: 'Kokende vann',
                image: 'static/img/Basic.png'
            }, {
                title: 'Design',
                type: 'classic',
                description: 'Kokende vann',
                image: 'static/img/design.png'
            }],
            surfaces: [{
                title: 'Krom',
                fits: 'flex,nordic,fusion,classic,cl-fusion,cl-nordic',
                image: 'static/img/overflade_krom-e1515075015591.png'
            }, {
                title: 'Børstet krom',
                fits: 'nordic,fusion,classic',
                image: 'static/img/borstet_krom-e1515075356409.png'
            }, {
                title: 'Rustfritt stål',
                fits: 'front,nordic,fusion,flex,cl-fusion,cl-nordic',
                image: 'static/img/rustfrit_staal-e1515074931468.png'
            }, {
                title: 'Black',
                fits: 'front,fusion,flex',
                image: 'static/img/sort-e1515075215324.png'
            }, {
                title: 'Messing',
                fits: 'nordic,fusion',
                image: 'static/img/messing-e1515075074718.png'
            }, {
                title: 'Aldret messing',
                fits: 'nordic,fusion,cl-fusion',
                image: 'static/img/bruneret_messing-e1515075086176.png'
            }, {
                title: 'Gull',
                fits: 'fusion,classic',
                image: 'static/img/guld-1-e1515075138363.png'
            }, {
                title: 'Rustfritt stål look',
                fits: 'classic',
                image: 'static/img/rustfrit_staal-e1515074931468.png'
            }, {
                title: 'Rose copper',
                fits: 'front,flex,fusion',
                image: 'static/img/rose-copper.png'
            }, {
                title: 'Gunmetal',
                fits: 'front,flex,fusion',
                image: 'static/img/gunmetal.png'
            }, {
                title: 'Vet ikke',
                fits: 'front,flex,nordic,fusion,classic,cl-fusion,cl-nordic',
                image: 'static/img/ved_ikke-e1515075230382.png'
            }],
            months: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
            serials: [{ identifier: 'VC3', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: 3127770, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: 307235, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399002, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCD3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399003, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBF3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBD3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399006, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW4', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW5', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW6', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VC5', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' }, { identifier: 'VCD5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VC7', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' }, { identifier: 'VCD7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CC4', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 434060, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' }, { identifier: 'CP4', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 419403, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' }, { identifier: 'CCE4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' }, { identifier: 'CPE4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' }, { identifier: 'CCF4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 403873, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPF4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 404361, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCD4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPD4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCW4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CC5', name: 'COMBI 3.0', slug: 'combi-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' }, { identifier: 'CP5', name: 'COMBI+ 3.0', slug: 'combi-plus-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' }, { identifier: 'CCF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' }, { identifier: 'CPF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' }, { identifier: 'CPE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW6', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-vcd3-vcw3', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-vbd3-vbw3-vbw4', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RCE', name: 'Combi 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-ccd-cpd-ccw-cpw', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-vcd5-vcw5', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RVR', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: null, taps: 'classic' }, { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RZR', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: null, taps: 'classic' }, { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RZB', name: 'PRO7-VAQ B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RCR', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' }, { identifier: 'RCE', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RCB', name: 'COMBI 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RPR', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' }, { identifier: 'RPE', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RPB', name: 'COMBI+ 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        var userLang = navigator.language || navigator.userLanguage;
        if (userLang && userLang.startsWith('da')) {
            this.showDanishAlert = true;
        }
        __WEBPACK_IMPORTED_MODULE_5__bugsnag_js___default.a.start({
            apiKey: 'fb2377299cc33e6414f0205412393375',
            plugins: [new __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue___default.a()]
        });
        this.$store.state.form.cube.own = false;

        var randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000);
        this.$store.state.form.meta.id = 'QSF-' + randomNumber;
        this.$store.state.form.cube.own = false;
        setInterval(function () {
            if (_this.currentStep === 1) {
                _this.validateSerial();
            }
        }, 500);
    },

    methods: {
        goToDanishForm: function goToDanishForm() {
            location.href = '/';
        },
        resetAddress: function resetAddress() {
            this.$store.state.form.contact.validatedAddress = null;
            this.$store.state.form.contact.address = null;
        },
        validateFaucet: function validateFaucet(faucet) {
            if (faucet.type === 'nordic') {
                this.showNordicChooser = true;
            } else {
                this.$store.state.form.faucet.meta = null;
            }
            this.$store.state.form.validatedFaucet = faucet;
        },
        chooseNordic: function chooseNordic(type) {
            this.$store.state.form.faucet.meta = type;
            this.showNordicChooser = false;
        },
        validateSerial: function validateSerial() {
            var _this2 = this;

            function compare(a, b) {
                if (a.identifier > b.identifier) {
                    return -1;
                }
                if (a.identifier < b.identifier) {
                    return 1;
                }
                return 0;
            }

            var input = this.$store.state.form.container.serial;
            if (input !== null) {
                input = input.toUpperCase();
            }

            this.serials.sort(compare);

            this.$store.state.form.validatedContainer = null;

            if (input !== null) {
                if (input.startsWith('Q')) {
                    this.faucetSerial = true;
                } else {
                    this.faucetSerial = false;
                }
                this.serials.every(function (serial) {
                    if (input.match('^' + serial.identifier)) {
                        _this2.$store.state.form.validatedContainer = serial;

                        return false;
                    }
                    return true;
                });
            }
        },
        submitForm: function submitForm() {
            var _this3 = this;

            if (this.$store.state.form.meta.id === null || this.$store.state.form.meta.id === '') {
                var randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000);
                this.$store.state.form.meta.id = 'QSF-' + randomNumber;
            }
            this.loading = true;

            var Email = { send: function send(a) {
                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (n, e) {
                        a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send";var t = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(a);Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) {
                            n(e);
                        });
                    });
                }, ajaxPost: function ajaxPost(e, n, t) {
                    var a = Email.createCORSRequest("POST", e);a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () {
                        var e = a.responseText;null != t && t(e);
                    }, a.send(n);
                }, ajax: function ajax(e, n) {
                    var t = Email.createCORSRequest("GET", e);t.onload = function () {
                        var e = t.responseText;null != n && n(e);
                    }, t.send();
                }, createCORSRequest: function createCORSRequest(e, n) {
                    var t = new XMLHttpRequest();return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest()).open(e, n) : t = null, t;
                } };


            var emailElement = document.getElementById('emailMockup').innerHTML;
            var quookerEmail = emailElement;

            var formData = new FormData();
            formData.append('email', this.$store.state.form.contact.email);
            formData.append('country', 'NO');
            formData.append('html', quookerEmail);
            formData.append('customer_name', this.$store.state.form.contact.firstname + ' ' + this.$store.state.form.contact.lastname);
            formData.append('form_meta_id', this.$store.state.form.meta.id);
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('https://serviceformapi.qservice.shop/api/submit-form', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                _this3.loading = false;
                _this3.currentStep = 8;
            }).catch(function (err) {
                console.log(err);
                alert('Der skete en fejl ved indsendelse af formularen. Prøv venligst igen eller kontakt os hvis problemet fortsætter.');
                _this3.loading = false;
            });
        }
    },
    computed: {
        showEmailChooser: function showEmailChooser() {
            var url = location.href;
            if (url.includes('localhost') || url.includes('test')) {
                return true;
            } else {
                return false;
            }
        },
        sortedFaucets: function sortedFaucets() {
            var _this4 = this;

            if (this.$store.state.form.validatedContainer !== null) {
                var arr = [];
                this.faucets.forEach(function (faucet) {
                    if (_this4.$store.state.form.validatedContainer.taps.includes(faucet.type)) {
                        arr.push(faucet);
                    }
                });
                return arr;
            }
        },
        sortedSurfaces: function sortedSurfaces() {
            var _this5 = this;

            if (this.$store.state.form.validatedFaucet !== null) {
                var arr = [];
                this.surfaces.forEach(function (surface) {
                    if (surface.fits.includes(_this5.$store.state.form.validatedFaucet.type)) {
                        arr.push(surface);
                    }
                });
                return arr;
            }
        },
        formattedEmailBody: function formattedEmailBody() {
            var body = {
                personalizations: [{
                    to: [{
                        email: 'nr@deveo.dk',
                        name: 'Nicolai Ramsby'
                    }],
                    subject: 'Hello, World!'
                }],
                content: [{
                    type: 'text/plain',
                    value: 'Heya!'
                }],
                from: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                },
                reply_to: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                }
            };
            return body;
        },
        years: function years() {
            var currentYear = new Date().getFullYear();
            var years = [];
            var startYear = 2004;

            while (startYear <= currentYear) {
                years.push(startYear++);
            }

            return years;
        },
        fullAddress: function fullAddress() {
            return this.address + ', ' + this.zipcode + ' ' + this.city;
        }
    },
    components: {
        ValidationMessages: __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessagesNO___default.a,
        FileUpload: __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload___default.a
    },
    validations: {
        address: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        zipcode: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        city: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        $store: {
            state: {
                form: {
                    problem: {
                        description: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(20),
                            maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(1000)
                        }
                    },
                    contact: {
                        firstname: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
                        },
                        lastname: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
                        },
                        email: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
                        },
                        phone: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
                        }
                    }
                }
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);











/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            faucetSerial: false,
            address: null,
            zipcode: null,
            city: null,
            loading: false,
            showSerialHelper: false,
            showTapSerialHelper: false,
            showBlinkHelper: false,
            show4BlinkHelper: false,
            showRestartHelper: false,
            currentStep: 0,
            showCubeInfo: false,
            showNordicChooser: false,
            faucets: [{
                title: 'Front',
                type: 'front',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/front-2.png'
            }, {
                title: 'Fusion Round',
                type: 'fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Fusion_Round_krom-1.png'
            }, {
                title: 'Fusion Square',
                type: 'fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Fusion-Square-krom-kopi.png'
            }, {
                title: 'Nordic Round',
                type: 'nordic',
                description: 'Kogende vand',
                image: 'static/img/Nordic_round.png'
            }, {
                title: 'Nordic Square',
                type: 'nordic',
                description: 'Kogende vand',
                image: 'static/img/Nordic_square.png'
            }, {
                title: 'Flex',
                type: 'flex',
                description: 'Koldt, varmt og kogende vand med udtræk',
                image: 'static/img/flex.png'
            }, {
                title: 'Classic Fusion Round',
                type: 'cl-fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Classic_Fusion_Round_krom.png'
            }, {
                title: 'Classic Fusion Square',
                type: 'cl-fusion',
                description: 'Koldt, varmt og kogende vand',
                image: 'static/img/Classic_Fusion_Square_krom.png'
            }, {
                title: 'Classic Nordic Round',
                type: 'cl-nordic',
                description: 'Kogende vand',
                image: 'static/img/Classic_Nordic_Round_krom.png'
            }, {
                title: 'Classic Nordic Square',
                type: 'cl-nordic',
                description: 'Kogende vand',
                image: 'static/img/Classic_Nordic_Square_krom.png'
            }, {
                title: 'Modern',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/modern.png'
            }, {
                title: 'Classic',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/classic.png'
            }, {
                title: 'Basic',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/Basic.png'
            }, {
                title: 'Design',
                type: 'classic',
                description: 'Kogende vand',
                image: 'static/img/design.png'
            }],
            surfaces: [{
                title: 'Krom',
                fits: 'flex,nordic,fusion,classic,cl-nordic,cl-fusion',
                image: 'static/img/overflade_krom-e1515075015591.png'
            }, {
                title: 'Børstet krom',
                fits: 'nordic,fusion,classic',
                image: 'static/img/borstet_krom-e1515075356409.png'
            }, {
                title: 'Rustfrit stål',
                fits: 'front,nordic,fusion,flex,cl-nordic,cl-fusion',
                image: 'static/img/rustfrit_staal-e1515074931468.png'
            }, {
                title: 'Black',
                fits: 'front,fusion,flex',
                image: 'static/img/sort-e1515075215324.png'
            }, {
                title: 'Messing',
                fits: 'nordic,fusion',
                image: 'static/img/messing-e1515075074718.png'
            }, {
                title: 'Bruneret messing',
                fits: 'nordic,fusion,cl-fusion',
                image: 'static/img/bruneret_messing-e1515075086176.png'
            }, {
                title: 'Guld',
                fits: 'fusion,classic',
                image: 'static/img/guld-1-e1515075138363.png'
            }, {
                title: 'Rustfrit stål-look',
                fits: 'classic',
                image: 'static/img/rustfrit_staal-e1515074931468.png'
            }, {
                title: 'Rose copper',
                fits: 'front,flex,fusion',
                image: 'static/img/rose-copper.png'
            }, {
                title: 'Gunmetal',
                fits: 'front,flex,fusion',
                image: 'static/img/gunmetal.png'
            }, {
                title: 'Ved ikke',
                fits: 'front,flex,nordic,fusion,classic,cl-fusion,cl-nordic',
                image: 'static/img/ved_ikke-e1515075230382.png'
            }],
            months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
            serials: [{ identifier: 'VC3', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: 3127770, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: 307235, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399002, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCD3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399003, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBF3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBD3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399006, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW4', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW5', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VBW6', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VC5', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' }, { identifier: 'VCD5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VC7', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' }, { identifier: 'VCE7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' }, { identifier: 'VCF7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' }, { identifier: 'VCD7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'VCW7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CC4', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 434060, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' }, { identifier: 'CP4', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 419403, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' }, { identifier: 'CCE4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' }, { identifier: 'CPE4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' }, { identifier: 'CCF4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 403873, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPF4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 404361, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCD4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPD4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCW4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CC5', name: 'COMBI 3.0', slug: 'combi-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' }, { identifier: 'CP5', name: 'COMBI+ 3.0', slug: 'combi-plus-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' }, { identifier: 'CCF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' }, { identifier: 'CPF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' }, { identifier: 'CPE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CPW6', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'CCW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-vcd3-vcw3', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-vbd3-vbw3-vbw4', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RCE', name: 'Combi 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-ccd-cpd-ccw-cpw', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-vcd5-vcw5', breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RVR', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: null, taps: 'classic' }, { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RZR', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: null, taps: 'classic' }, { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RZB', name: 'PRO7-VAQ B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RCR', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' }, { identifier: 'RCE', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RCB', name: 'COMBI 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }, { identifier: 'RPR', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' }, { identifier: 'RPE', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' }, { identifier: 'RPB', name: 'COMBI+ 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_5__bugsnag_js___default.a.start({
            apiKey: 'fb2377299cc33e6414f0205412393375',
            plugins: [new __WEBPACK_IMPORTED_MODULE_6__bugsnag_plugin_vue___default.a()]
        });
        var randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000);
        this.$store.state.form.meta.id = 'QSF-' + randomNumber;

        setInterval(function () {
            if (_this.currentStep === 1) {
                _this.validateSerial();
            }
        }, 500);
    },

    methods: {
        goToSwedishForm: function goToSwedishForm() {
            window.location = window.location + 'se';
        },
        setPixel: function setPixel(title) {
            window.fbq('trackCustom', title);
        },
        resetAddress: function resetAddress() {
            this.$store.state.form.contact.validatedAddress = null;
            this.$store.state.form.contact.address = null;
        },
        validateFaucet: function validateFaucet(faucet) {
            if (faucet.type === 'nordic') {
                this.showNordicChooser = true;
            } else {
                this.$store.state.form.faucet.meta = null;
            }
            this.$store.state.form.validatedFaucet = faucet;
        },
        chooseNordic: function chooseNordic(type) {
            this.$store.state.form.faucet.meta = type;
            this.showNordicChooser = false;
        },
        validateSerial: function validateSerial() {
            var _this2 = this;

            function compare(a, b) {
                if (a.identifier > b.identifier) {
                    return -1;
                }
                if (a.identifier < b.identifier) {
                    return 1;
                }
                return 0;
            }

            var input = this.$store.state.form.container.serial;
            if (input !== null) {
                input = input.toUpperCase();
            }

            this.serials.sort(compare);

            this.$store.state.form.validatedContainer = null;

            if (input !== null) {
                if (input.startsWith('Q')) {
                    this.faucetSerial = true;
                } else {
                    this.faucetSerial = false;
                }
                this.serials.every(function (serial) {
                    if (input.match('^' + serial.identifier)) {
                        _this2.$store.state.form.validatedContainer = serial;

                        return false;
                    }
                    return true;
                });
            }
        },
        submitForm: function submitForm() {
            var _this3 = this;

            if (this.$store.state.form.meta.id === null || this.$store.state.form.meta.id === '') {
                var randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000);
                this.$store.state.form.meta.id = 'QSF-' + randomNumber;
            }
            this.loading = true;

            var Email = { send: function send(a) {
                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (n, e) {
                        a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send";var t = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(a);Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) {
                            n(e);
                        });
                    });
                }, ajaxPost: function ajaxPost(e, n, t) {
                    var a = Email.createCORSRequest("POST", e);a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () {
                        var e = a.responseText;null != t && t(e);
                    }, a.send(n);
                }, ajax: function ajax(e, n) {
                    var t = Email.createCORSRequest("GET", e);t.onload = function () {
                        var e = t.responseText;null != n && n(e);
                    }, t.send();
                }, createCORSRequest: function createCORSRequest(e, n) {
                    var t = new XMLHttpRequest();return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest()).open(e, n) : t = null, t;
                } };


            var emailElement = document.getElementById('emailMockup').innerHTML;
            var quookerEmail = emailElement;
            var formData = new FormData();
            formData.append('email', this.$store.state.form.contact.email);
            formData.append('country', 'SE');
            formData.append('html', quookerEmail);
            formData.append('customer_name', this.$store.state.form.contact.firstname + ' ' + this.$store.state.form.contact.lastname);
            formData.append('form_meta_id', this.$store.state.form.meta.id);
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('https://serviceformapi.qservice.shop/api/submit-form', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                _this3.loading = false;
                _this3.currentStep = 8;
            }).catch(function (err) {
                console.log(err);
                alert('Der skete en fejl ved indsendelse af formularen. Prøv venligst igen eller kontakt os hvis problemet fortsætter.');
                _this3.loading = false;
            });
        }
    },
    computed: {
        showEmailChooser: function showEmailChooser() {
            var url = location.href;
            if (url.includes('localhost') || url.includes('test')) {
                return true;
            } else {
                return false;
            }
        },
        sortedFaucets: function sortedFaucets() {
            var _this4 = this;

            if (this.$store.state.form.validatedContainer !== null) {
                var arr = [];
                this.faucets.forEach(function (faucet) {
                    if (_this4.$store.state.form.validatedContainer.taps.includes(faucet.type)) {
                        arr.push(faucet);
                    }
                });
                return arr;
            }
        },
        sortedSurfaces: function sortedSurfaces() {
            var _this5 = this;

            if (this.$store.state.form.validatedFaucet !== null) {
                var arr = [];
                this.surfaces.forEach(function (surface) {
                    if (surface.fits.includes(_this5.$store.state.form.validatedFaucet.type)) {
                        arr.push(surface);
                    }
                });
                return arr;
            }
        },
        formattedEmailBody: function formattedEmailBody() {
            var body = {
                personalizations: [{
                    to: [{
                        email: 'nr@deveo.dk',
                        name: 'Nicolai Ramsby'
                    }],
                    subject: 'Hello, World!'
                }],
                content: [{
                    type: 'text/plain',
                    value: 'Heya!'
                }],
                from: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                },
                reply_to: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                }
            };
            return body;
        },
        years: function years() {
            var currentYear = new Date().getFullYear();
            var years = [];
            var startYear = 2004;

            while (startYear <= currentYear) {
                years.push(startYear++);
            }

            return years;
        },
        fullAddress: function fullAddress() {
            return this.address + ', ' + this.zipcode + ' ' + this.city;
        }
    },
    components: {
        ValidationMessages: __WEBPACK_IMPORTED_MODULE_3__components_validation_validationMessages___default.a,
        FileUpload: __WEBPACK_IMPORTED_MODULE_4__components_elements_file_upload___default.a
    },
    validations: {
        address: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        zipcode: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        city: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        $store: {
            state: {
                form: {
                    problem: {
                        description: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(20),
                            maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(1000)
                        }
                    },
                    contact: {
                        firstname: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
                        },
                        lastname: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
                        },
                        email: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
                            email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
                        },
                        phone: {
                            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
                        }
                    }
                }
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 73,
	"./af.js": 73,
	"./ar": 80,
	"./ar-dz": 74,
	"./ar-dz.js": 74,
	"./ar-kw": 75,
	"./ar-kw.js": 75,
	"./ar-ly": 76,
	"./ar-ly.js": 76,
	"./ar-ma": 77,
	"./ar-ma.js": 77,
	"./ar-sa": 78,
	"./ar-sa.js": 78,
	"./ar-tn": 79,
	"./ar-tn.js": 79,
	"./ar.js": 80,
	"./az": 81,
	"./az.js": 81,
	"./be": 82,
	"./be.js": 82,
	"./bg": 83,
	"./bg.js": 83,
	"./bm": 84,
	"./bm.js": 84,
	"./bn": 85,
	"./bn.js": 85,
	"./bo": 86,
	"./bo.js": 86,
	"./br": 87,
	"./br.js": 87,
	"./bs": 88,
	"./bs.js": 88,
	"./ca": 89,
	"./ca.js": 89,
	"./cs": 90,
	"./cs.js": 90,
	"./cv": 91,
	"./cv.js": 91,
	"./cy": 92,
	"./cy.js": 92,
	"./da": 36,
	"./da.js": 36,
	"./de": 95,
	"./de-at": 93,
	"./de-at.js": 93,
	"./de-ch": 94,
	"./de-ch.js": 94,
	"./de.js": 95,
	"./dv": 96,
	"./dv.js": 96,
	"./el": 97,
	"./el.js": 97,
	"./en-SG": 98,
	"./en-SG.js": 98,
	"./en-au": 99,
	"./en-au.js": 99,
	"./en-ca": 100,
	"./en-ca.js": 100,
	"./en-gb": 101,
	"./en-gb.js": 101,
	"./en-ie": 102,
	"./en-ie.js": 102,
	"./en-il": 103,
	"./en-il.js": 103,
	"./en-nz": 104,
	"./en-nz.js": 104,
	"./eo": 105,
	"./eo.js": 105,
	"./es": 108,
	"./es-do": 106,
	"./es-do.js": 106,
	"./es-us": 107,
	"./es-us.js": 107,
	"./es.js": 108,
	"./et": 109,
	"./et.js": 109,
	"./eu": 110,
	"./eu.js": 110,
	"./fa": 111,
	"./fa.js": 111,
	"./fi": 112,
	"./fi.js": 112,
	"./fo": 113,
	"./fo.js": 113,
	"./fr": 116,
	"./fr-ca": 114,
	"./fr-ca.js": 114,
	"./fr-ch": 115,
	"./fr-ch.js": 115,
	"./fr.js": 116,
	"./fy": 117,
	"./fy.js": 117,
	"./ga": 118,
	"./ga.js": 118,
	"./gd": 119,
	"./gd.js": 119,
	"./gl": 120,
	"./gl.js": 120,
	"./gom-latn": 121,
	"./gom-latn.js": 121,
	"./gu": 122,
	"./gu.js": 122,
	"./he": 123,
	"./he.js": 123,
	"./hi": 124,
	"./hi.js": 124,
	"./hr": 125,
	"./hr.js": 125,
	"./hu": 126,
	"./hu.js": 126,
	"./hy-am": 127,
	"./hy-am.js": 127,
	"./id": 128,
	"./id.js": 128,
	"./is": 129,
	"./is.js": 129,
	"./it": 131,
	"./it-ch": 130,
	"./it-ch.js": 130,
	"./it.js": 131,
	"./ja": 132,
	"./ja.js": 132,
	"./jv": 133,
	"./jv.js": 133,
	"./ka": 134,
	"./ka.js": 134,
	"./kk": 135,
	"./kk.js": 135,
	"./km": 136,
	"./km.js": 136,
	"./kn": 137,
	"./kn.js": 137,
	"./ko": 138,
	"./ko.js": 138,
	"./ku": 139,
	"./ku.js": 139,
	"./ky": 140,
	"./ky.js": 140,
	"./lb": 141,
	"./lb.js": 141,
	"./lo": 142,
	"./lo.js": 142,
	"./lt": 143,
	"./lt.js": 143,
	"./lv": 144,
	"./lv.js": 144,
	"./me": 145,
	"./me.js": 145,
	"./mi": 146,
	"./mi.js": 146,
	"./mk": 147,
	"./mk.js": 147,
	"./ml": 148,
	"./ml.js": 148,
	"./mn": 149,
	"./mn.js": 149,
	"./mr": 150,
	"./mr.js": 150,
	"./ms": 152,
	"./ms-my": 151,
	"./ms-my.js": 151,
	"./ms.js": 152,
	"./mt": 153,
	"./mt.js": 153,
	"./my": 154,
	"./my.js": 154,
	"./nb": 155,
	"./nb.js": 155,
	"./ne": 156,
	"./ne.js": 156,
	"./nl": 158,
	"./nl-be": 157,
	"./nl-be.js": 157,
	"./nl.js": 158,
	"./nn": 159,
	"./nn.js": 159,
	"./pa-in": 160,
	"./pa-in.js": 160,
	"./pl": 161,
	"./pl.js": 161,
	"./pt": 163,
	"./pt-br": 162,
	"./pt-br.js": 162,
	"./pt.js": 163,
	"./ro": 164,
	"./ro.js": 164,
	"./ru": 165,
	"./ru.js": 165,
	"./sd": 166,
	"./sd.js": 166,
	"./se": 167,
	"./se.js": 167,
	"./si": 168,
	"./si.js": 168,
	"./sk": 169,
	"./sk.js": 169,
	"./sl": 170,
	"./sl.js": 170,
	"./sq": 171,
	"./sq.js": 171,
	"./sr": 173,
	"./sr-cyrl": 172,
	"./sr-cyrl.js": 172,
	"./sr.js": 173,
	"./ss": 174,
	"./ss.js": 174,
	"./sv": 175,
	"./sv.js": 175,
	"./sw": 176,
	"./sw.js": 176,
	"./ta": 177,
	"./ta.js": 177,
	"./te": 178,
	"./te.js": 178,
	"./tet": 179,
	"./tet.js": 179,
	"./tg": 180,
	"./tg.js": 180,
	"./th": 181,
	"./th.js": 181,
	"./tl-ph": 182,
	"./tl-ph.js": 182,
	"./tlh": 183,
	"./tlh.js": 183,
	"./tr": 184,
	"./tr.js": 184,
	"./tzl": 185,
	"./tzl.js": 185,
	"./tzm": 187,
	"./tzm-latn": 186,
	"./tzm-latn.js": 186,
	"./tzm.js": 187,
	"./ug-cn": 188,
	"./ug-cn.js": 188,
	"./uk": 189,
	"./uk.js": 189,
	"./ur": 190,
	"./ur.js": 190,
	"./uz": 192,
	"./uz-latn": 191,
	"./uz-latn.js": 191,
	"./uz.js": 192,
	"./vi": 193,
	"./vi.js": 193,
	"./x-pseudo": 194,
	"./x-pseudo.js": 194,
	"./yo": 195,
	"./yo.js": 195,
	"./zh-cn": 196,
	"./zh-cn.js": 196,
	"./zh-hk": 197,
	"./zh-hk.js": 197,
	"./zh-tw": 198,
	"./zh-tw.js": 198
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 326;

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)

var Component = __webpack_require__(7)(
  /* script */
  null,
  /* template */
  __webpack_require__(355),
  /* scopeId */
  "data-v-87b029dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(347),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(7)(
  /* script */
  null,
  /* template */
  __webpack_require__(348),
  /* scopeId */
  "data-v-301a1469",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(346),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(352),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(323)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(356),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(324)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(351),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 346:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "info-message"
  }, [_vm._v("\n            Scroll evt. for at se alle felter\n        ")]), _vm._v(" "), (_vm.showEmailChooser) ? _c('div', {
    staticClass: "email-chooser"
  }, [_vm._v("\n            Send test e-mail til:\n            "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.default.email),
      expression: "$store.state.form.default.email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.default.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.default, "email", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1;
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 1),
      expression: "currentStep === 1"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === '') ? _c('span', [_vm._v("\n                        Udfyld alle felter markeret med \""), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")]), _vm._v("\" for at gå videre \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === ''
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(3), _vm._v("\n                        Serienummeret finder du på et mærkat på siden af beholderen. Hvis du er i tvivl, se\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showSerialHelper = !_vm.showSerialHelper
      }
    }
  }, [_vm._v("her")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSerialHelper),
      expression: "showSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "max-height": "240px",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-beholder.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.container.serial),
      expression: "$store.state.form.container.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.container.serial)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateSerial()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.container, "serial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mts"
  }, [(_vm.$store.state.form.validatedContainer !== null && _vm.$store.state.form.container.serial.length > 5) ? _c('span', {
    staticClass: "green"
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _c('span', [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length > 0) ? _c('span', {
    staticClass: "red"
  }, [_vm._v("\n                                    " + _vm._s(_vm.faucetSerial ? 'Det ser ud til, at du er ved at indtaste serienummeret på din hane og ikke din beholder. Skriv venligst serienummeret på din beholder i dette felt for at gå videre.' : 'Intet match fundet') + "\n                                ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(4), _vm._v("\n                        Du finder serienummeret på den sorte ledning fra armaturet. Hvis du er i tvivl, se\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = !_vm.showTapSerialHelper
      }
    }
  }, [_vm._v("her")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTapSerialHelper),
      expression: "showTapSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-hane.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.faucet.serial),
      expression: "$store.state.form.faucet.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.faucet.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.faucet, "serial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Serienummer på din CUBE\n                        ")]), _vm._v(" "), _vm._v("\n                        Hvis du har en CUBE køleenhed. Serienummeret findes på et klistermærke på enten forsiden eller bagsiden af CUBE.\n                        Hvis du er i tvivl, se\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showCubeSerialHelper = !_vm.showCubeSerialHelper
      }
    }
  }, [_vm._v("her")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCubeSerialHelper),
      expression: "showCubeSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "max-height": "240px",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-cube.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showCubeSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.cube.serial),
      expression: "$store.state.form.cube.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.cube.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.cube, "serial", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }],
    staticClass: "step"
  }, [(_vm.showNordicChooser) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Twintaps eller single tap Nordic?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Twintaps består af både en kogende vandhane og et almindeligt blandingsbatteri fra Quooker.\n                        Single tap er når du kun har en kogende vandhane fra Quooker.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Twintaps')
      }
    }
  }, [_vm._v("\n                            Twintaps\n                        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Single Tap')
      }
    }
  }, [_vm._v("\n                            Single tap\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.validatedFaucet === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 3;
        _vm.setPixel('Vaelg overflade')
      }
    }
  }, [(_vm.$store.state.form.validatedFaucet === null) ? _c('span', [_vm._v("\n                            Hane skal vælges\n                        ")]) : _c('span', [_vm._v("\n                            Videre\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "faucets"
  }, _vm._l((_vm.sortedFaucets), function(faucet) {
    return _c('div', {
      key: faucet.title,
      staticClass: "faucet",
      class: {
        'selected': _vm.$store.state.form.validatedFaucet !== null && _vm.$store.state.form.validatedFaucet.title === faucet.title
      },
      on: {
        "click": function($event) {
          return _vm.validateFaucet(faucet)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": faucet.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(faucet.title) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n                            " + _vm._s(faucet.description) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 3),
      expression: "currentStep === 3"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.faucet.surface === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 4;
        _vm.setPixel('Problem aarsag')
      }
    }
  }, [(_vm.$store.state.form.faucet.surface === null) ? _c('span', [_vm._v("\n                            Overflade skal vælges\n                        ")]) : _c('span', [_vm._v("\n                            Videre\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "surfaces"
  }, _vm._l((_vm.sortedSurfaces), function(surface) {
    return _c('div', {
      key: surface.title,
      staticClass: "surface",
      class: {
        'selected': _vm.$store.state.form.faucet.surface === surface.title
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.faucet.surface = surface.title
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "sm",
      attrs: {
        "src": surface.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(surface.title) + "\n                        ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 4),
      expression: "currentStep === 4"
    }],
    staticClass: "step"
  }, [(_vm.showRestartHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Sådan nulstiller du din Quooker\n                    ")]), _vm._v("\n                    Mange fejl kan med succes afhjælpes, med en simpel genstart og nulstilling af softwaren i Quookeren.\n                    "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("\n                        Se her hvordan du genstarter din Quooker korrekt")]), _vm._v(".\n                    "), _c('br'), _c('br'), _vm._v("\n                    Det er ikke nok bare at hive stikket ud!\n                    "), _c('br'), _c('br'), _vm._v("\n                    Vi anbefaler du prøver at genstarte din Quooker korrekt nogle gange, inden du kontakter os.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        Luk vindue\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.showBlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showBlinkHelper = false;
        _vm.$store.state.form.problem.questions[2].answer = null
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Hvordan blinker din Quooker?\n                    ")]), _vm._v("\n                    Hvis Quookeren opdager en fejl/uregelmæssighed vil lyset i hanen og på beholderen blinke i et fast mønster.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "90%"
    }
  }, [_vm._v("OBS! I nogle tilfælde er det kun beholderen der blinker, tjek derfor altid både hanen og beholderen.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option-wrapper"
  }, [_c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '2 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '4 blink';
        _vm.showBlinkHelper = false;
        _vm.show4BlinkHelper = true
      }
    }
  }, [_vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '3 + 1 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(9)])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "option last",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = 'Andet / ved ikke';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._v("\n                            Andet / ved ikke\n                        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.show4BlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "max-height": "90%",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        4 blink\n                    ")]), _vm._v("\n                    4 blink på hane, eller beholder, betyder at softwaren i din Quooker registrerer en fejl i forbindelse med temperaturmålingen i din Quooker.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#C80236"
    }
  }, [_vm._v("Tips!")]), _c('br'), _vm._v("\n                    Fejlen kan ofte nulstilles, ved at give beholderen et \"kuldechok\""), _c('br'), _c('br'), _vm._v("\n                    Det gøres ved at slukke på beholderens top og tappe alt kogende vand af beholderen. Når vandet ikke længere er kogende, lader man vandet løbe i yderligere 2 minutter således at vandet er helt koldt."), _c('br'), _c('br'), _vm._v("\n                    Derefter skal du følge vores almindelige "), _c('a', {
    staticClass: "main",
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "target": "_blank"
    }
  }, [_vm._v("nulstillingsprocedure")]), _vm._v(", hvorefter beholderen burde være klar til brug efter ca. 20 minutter."), _c('br'), _c('br'), _vm._v("\n                    Manøvren kan være nødvendig at gentage et par gange"), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "unset",
      "outline": "none",
      "background": "#C80236",
      "color": "#fff",
      "border": "1px solid #e6003f!important",
      "padding": "5px 10px",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        OK, det prøver jeg!\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 3
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.problem.questions[0].answer === null || _vm.$v.$store.state.form.problem.$invalid || _vm.$store.state.form.problem.questions[1].answer === null || _vm.$store.state.form.problem.questions[2].answer === null || _vm.$store.state.form.problem.description === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 5;
        _vm.setPixel('Garanti')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.$store.state.form.problem.questions), function(question, index) {
    return _c('div', {
      key: question.question,
      staticClass: "line",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('label', [_vm._v("\n                            " + _vm._s(question.question) + "\n                        ")]), _vm._v(" "), (question.slug === 'restart') ? _c('div', [_vm._m(11, true)]) : _vm._e()]), _vm._v(" "), (index === 2) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true;
          _vm.showBlinkHelper = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.$store.state.form.problem.questions[index].extra = null
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])]) : (index === 3) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.showRestartHelper = true
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])]) : _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.problem.description),
      expression: "$store.state.form.problem.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Beskrivelse af problem",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.$store.state.form.problem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.problem, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper mts"
  }, [_c('validation-messages', {
    attrs: {
      "data": _vm.$v.$store.state.form.problem.description,
      "show": true
    }
  }), _vm._v(" "), (_vm.$store.state.form.problem.description) ? _c('div', {
    staticClass: "validator",
    class: {
      'validated': _vm.$store.state.form.problem.description.length > 19
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.problem.description.length) + " / 20\n                            ")]) : _vm._e()], 1)])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 5),
      expression: "currentStep === 5"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 4
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.warranty.underWarranty === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationMonth === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationYear === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 6;
        _vm.setPixel('Vedhæft filer')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === true
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = true
      }
    }
  }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === false
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = false
      }
    }
  }, [_vm._v("\n                            Nej\n                        ")])])]), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty === true) ? _c('div', {
    staticClass: "line"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationMonth),
      expression: "$store.state.form.warranty.installationMonth"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.months), function(month) {
    return _c('option', {
      key: month
    }, [_vm._v("\n                                " + _vm._s(month) + "\n                            ")])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationYear),
      expression: "$store.state.form.warranty.installationYear"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year
    }, [_vm._v("\n                                " + _vm._s(year) + "\n                            ")])
  }), 0)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 6),
      expression: "currentStep === 6"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 5
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 7;
        _vm.setPixel('Kontaktinformationer')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('file-upload', {
    attrs: {
      "intro": "Valgfrit - Upload billeder, video eller andre relevante filer, hvis du er blevet bedt om dette.<br><br><b style='font-family:AvenirHeavyOblique;'>OBS</b>&nbsp;&nbsp;Hvis din Quooker har mislyde, skal vi bede om en video<br><b style='font-family:AvenirHeavyOblique;color:#fff;'>OBS</b>&nbsp;&nbsp;Hvis din Quooker har fået en fysisk skade, skal vi bede om billeder",
      "singleFileUploaded": "fil uploadet",
      "multipleFilesUploaded": "filer uploadet",
      "noFilesUploaded": "Ingen filer uploadet",
      "addFilesButton": "Tilføj fil(er)",
      "remove": "Fjern"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 7),
      expression: "currentStep === 7"
    }],
    staticClass: "step"
  }, [(_vm.currentStep === 7) ? _c('div', {
    staticStyle: {
      "display": "none",
      "position": "absolute",
      "z-index": "999",
      "background": "#f8f9fc",
      "width": "100%"
    },
    attrs: {
      "id": "emailMockup"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "width": "400px",
      "margin": "25px auto"
    }
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.swedish)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Vigtigt!")]), _vm._v(" Har du spørgsmål bedes du besvare denne mail.\n                        "), _c('br'), _c('br'), _vm._v("\n                        Herunder finder du en kopi af dine indtastede oplysninger:\n                        "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "summary",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "border": "1px solid #ccc",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    }
  }, [_c('div', [_c('b', [_vm._v("Sagsnummer")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.meta.id) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Beholder")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.container.serial !== null) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.container.serial.toUpperCase()) + " - " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.cube.serial !== null) ? _c('div', [_c('b', [_vm._v("CUBE")]), _vm._v(" "), _c('br'), _vm._v("\n                            Serienummer: " + _vm._s(_vm.$store.state.form.cube.serial) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Hane")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.validatedFaucet.title) + "\n                            "), (_vm.$store.state.form.faucet.meta !== null) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.$store.state.form.faucet.meta) + ")\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.surface) + "\n                            ")]), _vm._v(" "), (_vm.$store.state.form.faucet.serial !== null) ? _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.serial) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Spørgsmål")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.$store.state.form.problem.questions), function(q) {
    return _c('div', [_vm._v("\n                                " + _vm._s(q.question) + ":\n                                "), (q.answer) ? _c('b', [_vm._v("\n                                    Ja\n                                ")]) : _c('b', [_vm._v("Nej")]), _vm._v(" "), (q.extra) ? _c('b', [_vm._v("\n                                    (" + _vm._s(q.extra) + ")\n                                ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Beskrivelse af problemet")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.problem.description) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Garanti")]), _vm._v(" "), _c('br'), _vm._v("\n                            Er produktet under 24 måneder?\n                            "), (_vm.$store.state.form.warranty.underWarranty) ? _c('b', [_vm._v("Ja")]) : _c('b', [_vm._v("Nej")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty) ? _c('span', [_vm._v("\n                                Installationsdato:\n                                "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.warranty.installationMonth) + " " + _vm._s(_vm.$store.state.form.warranty.installationYear))])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Kontaktoplysninger")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.firstname) + "\n                            " + _vm._s(_vm.$store.state.form.contact.lastname) + "\n                            "), _c('br'), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('span', [_vm._v("\n                                Firma: " + _vm._s(_vm.$store.state.form.contact.company) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('br') : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.phone) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.email) + "\n                            "), _c('br'), _vm._v(" "), (_vm.fullAddress !== null) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm.fullAddress) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Vedhæftninger")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.attachments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.$store.state.form.attachments), function(attachment) {
    return _c('li', {
      key: attachment.name
    }, [_c('a', {
      attrs: {
        "href": attachment.path
      }
    }, [_vm._v("\n                                            " + _vm._s(attachment.name) + "\n                                        ")])])
  }), 0)]) : _c('div', [_vm._v("\n                                Ingen filer uploadet\n                            ")])])]), _vm._v(" "), _vm._m(17)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 6
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.loading) ? _c('span', [_c('i', {
    staticClass: "fal fa-spinner fa-spin"
  }), _vm._v("\n                         \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.loading || _vm.$v.$store.state.form.contact.$invalid || _vm.$store.state.form.terms.accepted === false
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n                        Send\n                        "), _c('i', {
    staticClass: "fal fa-envelope"
  })])])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line three-columns"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.firstname),
      expression: "$store.state.form.contact.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.firstname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left middle"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.lastname),
      expression: "$store.state.form.contact.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.lastname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Firma (valgfri)\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.company),
      expression: "$store.state.form.contact.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.email),
      expression: "$store.state.form.contact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.email
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.phone),
      expression: "$store.state.form.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.phone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line address-field"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "calc(100% + 30px)"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-sm-6"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "2f3b92h83nfuiei9he",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-sm-2"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipcode),
      expression: "zipcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-4"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(26)])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left fw terms"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.terms.accepted),
      expression: "$store.state.form.terms.accepted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.form.terms.accepted) ? _vm._i(_vm.$store.state.form.terms.accepted, null) > -1 : (_vm.$store.state.form.terms.accepted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$store.state.form.terms.accepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.form.terms, "accepted", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })])])]), _vm._v(" "), (_vm.currentStep === 8) ? _c('div', {
    staticClass: "step"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.danish)
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                Sagsnummer: "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.meta.id))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Vi har sendt dig en mail hvor dit sagsnummer også er noteret. Modtager du ikke denne email inden for en time, så tjek først din spam-mappe og kontakt os dernæst evt. telefonisk i stedet.\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.currentStep !== 7) ? _c('div', {
    staticClass: "q-progress-bar"
  }, [_c('div', {
    staticClass: "line",
    style: ('width:' + ((16.66 * _vm.currentStep) - 16.66) + '%;')
  }), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 1
    }
  }, [_vm._v("\n            1\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 2
    }
  }, [_vm._v("\n            2\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 3
    }
  }, [_vm._v("\n            3\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 4
    }
  }, [_vm._v("\n            4\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 5
    }
  }, [_vm._v("\n            5\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 6
    }
  }, [_vm._v("\n            6\n        ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Kontaktformular (FO)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                         \n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                For at hjælpe dig bedst muligt, har vi brug for serienummeret på det produkt din henvendelse drejer sig om. Du skal som minimum altid indtaste serienummeret på din beholder, også selvom din henvendelse drejer sig om hanen, eller køleenheden.\n                "), _c('br'), _c('br'), _vm._v("\n                De fleste kunder vælger at indtaste serienumrene fra alle deres produkter, fordi man ved at gøre det, vil opnå den bedste, hurtigste og sikreste service fremover.\n                "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Angiv serienummer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        1 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Serienummer på din beholder "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Serienummer på din hane "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vælg hane\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        2 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vælg overflade\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        3 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink two"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    2 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinktwo.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink four"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    4 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkfour.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink threeplusone"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    3 + 1 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkthreeplusone.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Problem / årsag\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        4 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fal fa-video fa-fw"
  }), _vm._v("\n                                Sådan nulstiller du din Quooker\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Beskrivelse af problemet\n                        ")]), _vm._v("\n                        Beskriv dit problem eller spørgsmål i feltet her. Ved fejl er det vigtigt at uddybe symptomet; Hvad gør du og hvad sker der?\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Garanti\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        5 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Er produktet under 24 måneder gammelt?\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Installationsdato\n                        ")]), _vm._v("\n                        Vælg måned og år din Quooker blev installeret\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vedhæft filer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        6 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outro",
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _c('br'), _vm._v("\n                        Med venlig hilsen\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Quooker Skandinavien A/S")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Kontaktinformationer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        7 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Fornavn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Efternavn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            E-mail "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Telefon "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Adresse "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Postnr. "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                By "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "padding-top": "6px"
    }
  }, [_c('i', [_vm._v("Vi validerer ikke din adresse, sørg derfor for at indtaste din præcise adresse.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                            Jeg har læst og accepterer Quookers "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/privatlivspolitik",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("privatlivs- og forretningsbetingelser")]), _vm._v(" "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        INDSENDT - Tak for din henvendelse\n                    ")])])])
}]}

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOnline) ? _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1) : _c('offline')
},staticRenderFns: []}

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page-wrapper"
  }, [_c('div', {
    staticClass: "error-page-inner"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('h3', [_vm._v("Ups! Der er sket en fejl ...")]), _vm._v(" "), _c('p', [_vm._v("Vi ved ikke helt hvad der er sket, men vi kan desværre ikke vise denne side. Dette kan være fordi du har forsøgt at tilgå et dødt link eller fordi du ikke har adgang til denne side.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: _vm.$route.name
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Genindlæs siden\n            ")])]), _vm._v("\n        |\n        "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Gå til forsiden\n            ")])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show || _vm.data.$model !== '') ? _c('div', {
    staticClass: "validation-messages"
  }, [(_vm.data.$params.required && !_vm.data.required && _vm.data.length > 0) ? _c('div', {
    staticClass: "invalid-feedback v-required"
  }, [_vm._v("\n        Required\n    ")]) : _vm._e(), _vm._v(" "), (_vm.data.$params.minLength && _vm.data.$params.maxLength && _vm.data.$params.minLength.min === _vm.data.$params.maxLength.max) ? _c('div', [(!_vm.data.minLength || !_vm.data.maxLength) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("\n            Feltet skal være " + _vm._s(_vm.data.$params.minLength.min) + " karakterer\n        ")]) : _vm._e()]) : _c('div', [(_vm.show || _vm.data.$params.minLength && !_vm.data.minLength) ? _c('div', {
    staticClass: "invalid-feedback v-minlength"
  }, [_vm._v("\n            Feltet skal være min. " + _vm._s(_vm.data.$params.minLength.min) + " karakterer\n        ")]) : _vm._e(), _vm._v(" "), (_vm.data.$params.maxLength && !_vm.data.maxLength) ? _c('div', {
    staticClass: "invalid-feedback v-maxlength"
  }, [_vm._v("\n            Feltet må max være " + _vm._s(_vm.data.$params.maxLength.max) + " karakterer\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.data.$params.numeric && !_vm.data.numeric) ? _c('div', {
    staticClass: "invalid-feedback v-numeric"
  }, [_vm._v("\n        Feltet må kun indeholde tal\n    ")]) : _vm._e(), _vm._v(" "), (_vm.data.$params.alpha && !_vm.data.alpha) ? _c('div', {
    staticClass: "invalid-feedback v-alpha"
  }, [_vm._v("\n        Feltet må kun indeholde bogstaver og tegn\n    ")]) : _vm._e(), _vm._v(" "), (_vm.data.$params.alphaNum && !_vm.data.alphaNum) ? _c('div', {
    staticClass: "invalid-feedback v-alphanum"
  }, [_vm._v("\n        Feltet må kun indeholde bogstaver, tegn og tal\n    ")]) : _vm._e(), _vm._v(" "), (_vm.data.$params.email && !_vm.data.email) ? _c('div', {
    staticClass: "invalid-feedback v-email"
  }, [_vm._v("\n        Ugyldigt e-mail format\n    ")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('layout')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "info-message"
  }, [_vm._v("\n            Scroll evt. for at se alle felter\n        ")]), _vm._v(" "), (_vm.showEmailChooser) ? _c('div', {
    staticClass: "email-chooser"
  }, [_vm._v("\n            Send test e-mail til:\n            "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.default.email),
      expression: "$store.state.form.default.email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.default.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.default, "email", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1;
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 1),
      expression: "currentStep === 1"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === '') ? _c('span', [_vm._v("\n                        Udfyld alle felter markeret med \""), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")]), _vm._v("\" for at gå videre \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === ''
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(3), _vm._v("\n                        Serienummeret finder du på et mærkat på siden af beholderen. Hvis du er i tvivl, se\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showSerialHelper = !_vm.showSerialHelper
      }
    }
  }, [_vm._v("her")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSerialHelper),
      expression: "showSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "max-height": "240px",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-beholder.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.container.serial),
      expression: "$store.state.form.container.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.container.serial)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateSerial()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.container, "serial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mts"
  }, [(_vm.$store.state.form.validatedContainer !== null && _vm.$store.state.form.container.serial.length > 5) ? _c('span', {
    staticClass: "green"
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _c('span', [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length > 0) ? _c('span', {
    staticClass: "red"
  }, [_vm._v("\n                                    " + _vm._s(_vm.faucetSerial ? 'Det ser ud til, at du er ved at indtaste serienummeret på din hane og ikke din beholder. Skriv venligst serienummeret på din beholder i dette felt for at gå videre.' : 'Intet match fundet') + "\n                                ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(4), _vm._v("\n                        Du finder serienummeret på den sorte ledning fra armaturet. Hvis du er i tvivl, se\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = !_vm.showTapSerialHelper
      }
    }
  }, [_vm._v("her")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTapSerialHelper),
      expression: "showTapSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-hane.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.faucet.serial),
      expression: "$store.state.form.faucet.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.faucet.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.faucet, "serial", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }],
    staticClass: "step"
  }, [(_vm.showNordicChooser) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Twintaps eller single tap Nordic?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Twintaps består af både en kogende vandhane og et almindeligt blandingsbatteri fra Quooker.\n                        Single tap er når du kun har en kogende vandhane fra Quooker.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Twintaps')
      }
    }
  }, [_vm._v("\n                            Twintaps\n                        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Single Tap')
      }
    }
  }, [_vm._v("\n                            Single tap\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.validatedFaucet === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 3;
        _vm.setPixel('Vaelg overflade')
      }
    }
  }, [(_vm.$store.state.form.validatedFaucet === null) ? _c('span', [_vm._v("\n                            Hane skal vælges\n                        ")]) : _c('span', [_vm._v("\n                            Videre\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "faucets"
  }, _vm._l((_vm.sortedFaucets), function(faucet) {
    return _c('div', {
      key: faucet.title,
      staticClass: "faucet",
      class: {
        'selected': _vm.$store.state.form.validatedFaucet !== null && _vm.$store.state.form.validatedFaucet.title === faucet.title
      },
      on: {
        "click": function($event) {
          return _vm.validateFaucet(faucet)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": faucet.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(faucet.title) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n                            " + _vm._s(faucet.description) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 3),
      expression: "currentStep === 3"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.faucet.surface === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 4;
        _vm.setPixel('Problem aarsag')
      }
    }
  }, [(_vm.$store.state.form.faucet.surface === null) ? _c('span', [_vm._v("\n                            Overflade skal vælges\n                        ")]) : _c('span', [_vm._v("\n                            Videre\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "surfaces"
  }, _vm._l((_vm.sortedSurfaces), function(surface) {
    return _c('div', {
      key: surface.title,
      staticClass: "surface",
      class: {
        'selected': _vm.$store.state.form.faucet.surface === surface.title
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.faucet.surface = surface.title
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "sm",
      attrs: {
        "src": surface.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(surface.title) + "\n                        ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 4),
      expression: "currentStep === 4"
    }],
    staticClass: "step"
  }, [(_vm.showRestartHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Sådan nulstiller du din Quooker\n                    ")]), _vm._v("\n                    Mange fejl kan med succes afhjælpes, med en simpel genstart og nulstilling af softwaren i Quookeren.\n                    "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("\n                        Se her hvordan du genstarter din Quooker korrekt")]), _vm._v(".\n                    "), _c('br'), _c('br'), _vm._v("\n                    Det er ikke nok bare at hive stikket ud!\n                    "), _c('br'), _c('br'), _vm._v("\n                    Vi anbefaler du prøver at genstarte din Quooker korrekt nogle gange, inden du kontakter os.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        Luk vindue\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.showBlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showBlinkHelper = false;
        _vm.$store.state.form.problem.questions[2].answer = null
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Hvordan blinker din Quooker?\n                    ")]), _vm._v("\n                    Hvis Quookeren opdager en fejl/uregelmæssighed vil lyset i hanen og på beholderen blinke i et fast mønster.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "90%"
    }
  }, [_vm._v("OBS! I nogle tilfælde er det kun beholderen der blinker, tjek derfor altid både hanen og beholderen.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option-wrapper"
  }, [_c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '2 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '4 blink';
        _vm.showBlinkHelper = false;
        _vm.show4BlinkHelper = true
      }
    }
  }, [_vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '3 + 1 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(9)])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "option last",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = 'Andet / ved ikke';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._v("\n                            Andet / ved ikke\n                        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.show4BlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "max-height": "90%",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        4 blink\n                    ")]), _vm._v("\n                    4 blink på hane, eller beholder, betyder at softwaren i din Quooker registrerer en fejl i forbindelse med temperaturmålingen i din Quooker.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#C80236"
    }
  }, [_vm._v("Tips!")]), _c('br'), _vm._v("\n                    Fejlen kan ofte nulstilles, ved at give beholderen et \"kuldechok\""), _c('br'), _c('br'), _vm._v("\n                    Det gøres ved at slukke på beholderens top og tappe alt kogende vand af beholderen. Når vandet ikke længere er kogende, lader man vandet løbe i yderligere 2 minutter således at vandet er helt koldt."), _c('br'), _c('br'), _vm._v("\n                    Derefter skal du følge vores almindelige "), _c('a', {
    staticClass: "main",
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "target": "_blank"
    }
  }, [_vm._v("nulstillingsprocedure")]), _vm._v(", hvorefter beholderen burde være klar til brug efter ca. 20 minutter."), _c('br'), _c('br'), _vm._v("\n                    Manøvren kan være nødvendig at gentage et par gange"), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "unset",
      "outline": "none",
      "background": "#C80236",
      "color": "#fff",
      "border": "1px solid #e6003f!important",
      "padding": "5px 10px",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        OK, det prøver jeg!\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 3
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.problem.questions[0].answer === null || _vm.$v.$store.state.form.problem.$invalid || _vm.$store.state.form.problem.questions[1].answer === null || _vm.$store.state.form.problem.questions[2].answer === null || _vm.$store.state.form.problem.description === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 5;
        _vm.setPixel('Garanti')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.$store.state.form.problem.questions), function(question, index) {
    return _c('div', {
      key: question.question,
      staticClass: "line",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('label', [_vm._v("\n                            " + _vm._s(question.question) + "\n                        ")]), _vm._v(" "), (question.slug === 'restart') ? _c('div', [_vm._m(11, true)]) : _vm._e()]), _vm._v(" "), (index === 2) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true;
          _vm.showBlinkHelper = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.$store.state.form.problem.questions[index].extra = null
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])]) : (index === 3) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.showRestartHelper = true
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])]) : _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.problem.description),
      expression: "$store.state.form.problem.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Beskrivelse af problem",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.$store.state.form.problem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.problem, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper mts"
  }, [_c('validation-messages', {
    attrs: {
      "data": _vm.$v.$store.state.form.problem.description,
      "show": true
    }
  }), _vm._v(" "), (_vm.$store.state.form.problem.description) ? _c('div', {
    staticClass: "validator",
    class: {
      'validated': _vm.$store.state.form.problem.description.length > 19
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.problem.description.length) + " / 20\n                            ")]) : _vm._e()], 1)])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 5),
      expression: "currentStep === 5"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 4
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.warranty.underWarranty === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationMonth === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationYear === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 6;
        _vm.setPixel('Vedhæft filer')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === true
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = true
      }
    }
  }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === false
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = false
      }
    }
  }, [_vm._v("\n                            Nej\n                        ")])])]), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty === true) ? _c('div', {
    staticClass: "line"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationMonth),
      expression: "$store.state.form.warranty.installationMonth"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.months), function(month) {
    return _c('option', {
      key: month
    }, [_vm._v("\n                                " + _vm._s(month) + "\n                            ")])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationYear),
      expression: "$store.state.form.warranty.installationYear"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year
    }, [_vm._v("\n                                " + _vm._s(year) + "\n                            ")])
  }), 0)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 6),
      expression: "currentStep === 6"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 5
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 7;
        _vm.setPixel('Kontaktinformationer')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('file-upload', {
    attrs: {
      "intro": "Valgfrit - Upload billeder, video eller andre relevante filer, hvis du er blevet bedt om dette.<br><br><b style='font-family:AvenirHeavyOblique;'>OBS</b>&nbsp;&nbsp;Hvis din Quooker har mislyde, skal vi bede om en video<br><b style='font-family:AvenirHeavyOblique;color:#fff;'>OBS</b>&nbsp;&nbsp;Hvis din Quooker har fået en fysisk skade, skal vi bede om billeder",
      "singleFileUploaded": "fil uploadet",
      "multipleFilesUploaded": "filer uploadet",
      "noFilesUploaded": "Ingen filer uploadet",
      "addFilesButton": "Tilføj fil(er)",
      "remove": "Fjern"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 7),
      expression: "currentStep === 7"
    }],
    staticClass: "step"
  }, [(_vm.currentStep === 7) ? _c('div', {
    staticStyle: {
      "display": "none",
      "position": "absolute",
      "z-index": "999",
      "background": "#f8f9fc",
      "width": "100%"
    },
    attrs: {
      "id": "emailMockup"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "width": "400px",
      "margin": "25px auto"
    }
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.swedish)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Vigtigt!")]), _vm._v(" Har du spørgsmål bedes du besvare denne mail.\n                        "), _c('br'), _c('br'), _vm._v("\n                        Herunder finder du en kopi af dine indtastede oplysninger:\n                        "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "summary",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "border": "1px solid #ccc",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    }
  }, [_c('div', [_c('b', [_vm._v("Sagsnummer")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.meta.id) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Beholder")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.container.serial !== null) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.container.serial.toUpperCase()) + " - " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Hane")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.validatedFaucet.title) + "\n                            "), (_vm.$store.state.form.faucet.meta !== null) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.$store.state.form.faucet.meta) + ")\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.surface) + "\n                            ")]), _vm._v(" "), (_vm.$store.state.form.faucet.serial !== null) ? _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.serial) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Spørgsmål")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.$store.state.form.problem.questions), function(q) {
    return _c('div', [_vm._v("\n                                " + _vm._s(q.question) + ":\n                                "), (q.answer) ? _c('b', [_vm._v("\n                                    Ja\n                                ")]) : _c('b', [_vm._v("Nej")]), _vm._v(" "), (q.extra) ? _c('b', [_vm._v("\n                                    (" + _vm._s(q.extra) + ")\n                                ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Beskrivelse af problemet")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.problem.description) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Garanti")]), _vm._v(" "), _c('br'), _vm._v("\n                            Er produktet under 24 måneder?\n                            "), (_vm.$store.state.form.warranty.underWarranty) ? _c('b', [_vm._v("Ja")]) : _c('b', [_vm._v("Nej")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty) ? _c('span', [_vm._v("\n                                Installationsdato:\n                                "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.warranty.installationMonth) + " " + _vm._s(_vm.$store.state.form.warranty.installationYear))])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Kontaktoplysninger")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.firstname) + "\n                            " + _vm._s(_vm.$store.state.form.contact.lastname) + "\n                            "), _c('br'), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('span', [_vm._v("\n                                Firma: " + _vm._s(_vm.$store.state.form.contact.company) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('br') : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.phone) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.email) + "\n                            "), _c('br'), _vm._v(" "), (_vm.fullAddress !== null) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm.fullAddress) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Vedhæftninger")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.attachments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.$store.state.form.attachments), function(attachment) {
    return _c('li', {
      key: attachment.name
    }, [_c('a', {
      attrs: {
        "href": attachment.path
      }
    }, [_vm._v("\n                                            " + _vm._s(attachment.name) + "\n                                        ")])])
  }), 0)]) : _c('div', [_vm._v("\n                                Ingen filer uploadet\n                            ")])])]), _vm._v(" "), _vm._m(17)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 6
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.loading) ? _c('span', [_c('i', {
    staticClass: "fal fa-spinner fa-spin"
  }), _vm._v("\n                         \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.loading || _vm.$v.$store.state.form.contact.$invalid || _vm.$store.state.form.terms.accepted === false
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n                        Send\n                        "), _c('i', {
    staticClass: "fal fa-envelope"
  })])])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line three-columns"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.firstname),
      expression: "$store.state.form.contact.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.firstname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left middle"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.lastname),
      expression: "$store.state.form.contact.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.lastname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Firma (valgfri)\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.company),
      expression: "$store.state.form.contact.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.email),
      expression: "$store.state.form.contact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.email
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.phone),
      expression: "$store.state.form.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.phone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line address-field"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "calc(100% + 30px)"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-sm-6"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "2f3b92h83nfuiei9he",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-sm-2"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipcode),
      expression: "zipcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-4"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(26)])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left fw terms"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.terms.accepted),
      expression: "$store.state.form.terms.accepted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.form.terms.accepted) ? _vm._i(_vm.$store.state.form.terms.accepted, null) > -1 : (_vm.$store.state.form.terms.accepted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$store.state.form.terms.accepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.form.terms, "accepted", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })])])]), _vm._v(" "), (_vm.currentStep === 8) ? _c('div', {
    staticClass: "step"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.swedish)
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                Sagsnummer: "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.meta.id))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Vi har sendt dig en mail hvor dit sagsnummer også er noteret. Modtager du ikke denne email inden for en time, så tjek først din spam-mappe og kontakt os dernæst evt. telefonisk i stedet.\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.currentStep !== 7) ? _c('div', {
    staticClass: "q-progress-bar"
  }, [_c('div', {
    staticClass: "line",
    style: ('width:' + ((16.66 * _vm.currentStep) - 16.66) + '%;')
  }), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 1
    }
  }, [_vm._v("\n            1\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 2
    }
  }, [_vm._v("\n            2\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 3
    }
  }, [_vm._v("\n            3\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 4
    }
  }, [_vm._v("\n            4\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 5
    }
  }, [_vm._v("\n            5\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 6
    }
  }, [_vm._v("\n            6\n        ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Kontaktformular (SE)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                         \n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                For at hjælpe dig bedst muligt, har vi brug for serienummeret på det produkt din henvendelse drejer sig om. Du skal som minimum altid indtaste serienummeret på din beholder, også selvom din henvendelse drejer sig om hanen, eller køleenheden.\n                "), _c('br'), _c('br'), _vm._v("\n                De fleste kunder vælger at indtaste serienumrene fra alle deres produkter, fordi man ved at gøre det, vil opnå den bedste, hurtigste og sikreste service fremover.\n                "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Angiv serienummer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        1 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Serienummer på din beholder "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Serienummer på din hane "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vælg hane\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        2 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vælg overflade\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        3 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink two"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    2 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinktwo.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink four"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    4 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkfour.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink threeplusone"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    3 + 1 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkthreeplusone.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Problem / årsag\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        4 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fal fa-video fa-fw"
  }), _vm._v("\n                                Sådan nulstiller du din Quooker\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Beskrivelse af problemet\n                        ")]), _vm._v("\n                        Beskriv dit problem eller spørgsmål i feltet her. Ved fejl er det vigtigt at uddybe symptomet; Hvad gør du og hvad sker der?\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Garanti\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        5 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Er produktet under 24 måneder gammelt?\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Installationsdato\n                        ")]), _vm._v("\n                        Vælg måned og år din Quooker blev installeret\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vedhæft filer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        6 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outro",
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _c('br'), _vm._v("\n                        Med venlig hilsen\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Quooker Skandinavien A/S")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Kontaktinformationer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        7 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Fornavn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Efternavn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            E-mail "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Telefon "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Adresse "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Postnr. "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                By "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "padding-top": "6px"
    }
  }, [_c('i', [_vm._v("Vi validerer ikke din adresse, sørg derfor for at indtaste din præcise adresse.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                            Jeg har læst og accepterer Quookers "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/privatlivspolitik",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("privatlivs- og forretningsbetingelser")]), _vm._v(" "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        INDSENDT - Tak for din henvendelse\n                    ")])])])
}]}

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "info-message"
  }, [_vm._v("\n            Skrunaðu ef þörf krefur til að sjá alla reiti\n        ")]), _vm._v(" "), (_vm.showEmailChooser) ? _c('div', {
    staticClass: "email-chooser"
  }, [_vm._v("\n            Send test e-mail til:\n            "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultToEmail),
      expression: "defaultToEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.defaultToEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.defaultToEmail = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1;
      }
    }
  }, [_vm._v("\n                        Frekari\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 1),
      expression: "currentStep === 1"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === '') ? _c('span', [_vm._v("\n                        Fylltu út alla reiti merkta með \""), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")]), _vm._v("\" til að halda áfram\n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === ''
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_vm._v("\n                        Frekari\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(3), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showSerialHelper = !_vm.showSerialHelper
      }
    }
  }, [_vm._v("\n                            Hvernig á að finna raðnúmerið\n                        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSerialHelper),
      expression: "showSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Hvernig á að finna raðnúmerið")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "max-height": "240px",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-beholder.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Loka\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.container.serial),
      expression: "$store.state.form.container.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.container.serial)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateSerial()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.container, "serial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mts"
  }, [(_vm.$store.state.form.validatedContainer !== null && _vm.$store.state.form.container.serial.length > 5) ? _c('span', {
    staticClass: "green"
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _c('span', [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length > 0) ? _c('span', {
    staticClass: "red"
  }, [_vm._v("\n                                    " + _vm._s(_vm.faucetSerial ? 'Það lítur út fyrir að þú sért að slá inn raðnúmer blöndunartækisins en ekki ílátið þitt. Vinsamlegast sláðu inn raðnúmer ílátsins þíns í þennan reit til að halda áfram.' : 'Engar samsvörun fundust') + "\n                                ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(4), _vm._v("\n                        Þú getur fundið raðnúmerið á svarta vírnum frá innréttingunni.\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = !_vm.showTapSerialHelper
      }
    }
  }, [_vm._v("Hvernig á að finna raðnúmerið")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTapSerialHelper),
      expression: "showTapSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Hvernig á að finna raðnúmerið þitt")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-hane.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Loka\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.faucet.serial),
      expression: "$store.state.form.faucet.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.faucet.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.faucet, "serial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Raðnúmer CUBE þinnar\n                        ")]), _vm._v("\n                        Ef þú ert með CUBE kælibúnað. Finndu raðnúmerið á límmiðanum að framan, rétt fyrir neðan snertiskjáinn.\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showCubeSerialHelper = !_vm.showCubeSerialHelper
      }
    }
  }, [_vm._v("Hvernig á að finna raðnúmerið")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCubeSerialHelper),
      expression: "showCubeSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Hvernig á að finna raðnúmerið þitt")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-cube.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showCubeSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Loka\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.cube.serial),
      expression: "$store.state.form.cube.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.cube.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.cube, "serial", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }],
    staticClass: "step"
  }, [(_vm.showNordicChooser) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Twintaps eða Single tap Nordic?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Twintaps samanstendur af bæði sjóðandi vatnskrana og aðskildum blöndunartæki frá Quooker.\n                        Stakur krani er þegar þú ert bara með sjóðandi vatnskrana frá Quooker.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Twintaps')
      }
    }
  }, [_vm._v("\n                            Twintaps\n                        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Single Tap')
      }
    }
  }, [_vm._v("\n                            Single tap\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.validatedFaucet === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 3
      }
    }
  }, [(_vm.$store.state.form.validatedFaucet === null) ? _c('span', [_vm._v("\n                            Velja þarf blöndunartæki\n                        ")]) : _c('span', [_vm._v("\n                            Frekari\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "faucets"
  }, _vm._l((_vm.sortedFaucets), function(faucet) {
    return _c('div', {
      key: faucet.title,
      staticClass: "faucet",
      class: {
        'selected': _vm.$store.state.form.validatedFaucet !== null && _vm.$store.state.form.validatedFaucet.title === faucet.title
      },
      on: {
        "click": function($event) {
          return _vm.validateFaucet(faucet)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": faucet.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(faucet.title) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n                            " + _vm._s(faucet.description) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 3),
      expression: "currentStep === 3"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.faucet.surface === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 4
      }
    }
  }, [(_vm.$store.state.form.faucet.surface === null) ? _c('span', [_vm._v("\n                            Velja þarf yfirborð\n                        ")]) : _c('span', [_vm._v("\n                            Frekari\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "surfaces"
  }, _vm._l((_vm.sortedSurfaces), function(surface) {
    return _c('div', {
      key: surface.title,
      staticClass: "surface",
      class: {
        'selected': _vm.$store.state.form.faucet.surface === surface.title
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.faucet.surface = surface.title
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "sm",
      attrs: {
        "src": surface.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(surface.title) + "\n                        ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 4),
      expression: "currentStep === 4"
    }],
    staticClass: "step"
  }, [(_vm.showRestartHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Hvernig á að endurræsa Quooker\n                    ")]), _vm._v("\n                    Hægt er að leysa margar villur með einfaldri endurræsingu og endurstillingu Quooker hugbúnaðarins.\n                    "), _c('a', {
    attrs: {
      "href": "https://quooker.no/faq-generelt",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("\n                        Hvernig á að endurræsa Quooker")]), _vm._v(".\n                    "), _c('br'), _c('br'), _vm._v("\n                    Það er ekki nóg bara að aftengjast!\n                    "), _c('br'), _c('br'), _vm._v("\n                    Við mælum með því að þú reynir að ræsa Quooker rétt nokkrum sinnum áður en þú hefur samband við okkur.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        Loka\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.showBlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showBlinkHelper = false;
        _vm.$store.state.form.problem.questions[2].answer = null
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Hvernig blikkar Quooker blöndunartækið?\n                    ")]), _vm._v("\n                    Ef Quooker þinn finnur villu/óreglu mun ljósið á blöndunartækinu og ílátinu blikka í föstu mynstri.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "90%"
    }
  }, [_vm._v("ATHUGIÐ! Í sumum tilfellum blikkar aðeins ílátið og því er mikilvægt að athuga bæði krana og ílát.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option-wrapper"
  }, [_c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '2 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '4 blink';
        _vm.showBlinkHelper = false;
        _vm.show4BlinkHelper = true
      }
    }
  }, [_vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '3 + 1 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(9)])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "option last",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = 'Andet / ved ikke';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._v("\n                            Annað / veit ekki\n                        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.show4BlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "max-height": "90%",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        4 blikk\n                    ")]), _vm._v("\n                    4 fljótir blikkar á blöndunartækinu eða ílátinu þýðir að hugbúnaðurinn í Quooker þínum skráir villu í tengslum við hitamælingu í Quooker þínum.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#C80236"
    }
  }, [_vm._v("Ábending!")]), _c('br'), _vm._v("\n                    Oft er hægt að endurstilla villuna með því að gefa ílátinu svokallað „kuldasjokk“."), _c('br'), _c('br'), _vm._v("\n                    Það er gert með því að slökkva á ílátinu efst á ílátinu og tæma allt Sjóðandi vatn í ílátinu. Þegar vatnið er ekki að sjóða, láttu vatnið renna í 2 mínútur til viðbótar, svo við tryggjum að vatnið sé alveg kalt."), _c('br'), _c('br'), _vm._v("\n                    Fylgdu síðan almennu "), _c('a', {
    staticClass: "main",
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "target": "_blank"
    }
  }, [_vm._v("endurræsingaraðferðinni")]), _vm._v(" okkar og ílátið ætti að vera tilbúið til notkunar eftir ca. 20 mínútur."), _c('br'), _c('br'), _vm._v("\n                    Það gæti verið nauðsynlegt að endurtaka þessa aðferð nokkrum sinnum."), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "unset",
      "outline": "none",
      "background": "#C80236",
      "color": "#fff",
      "border": "1px solid #e6003f!important",
      "padding": "5px 10px",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        Allt í lagi, ég skal reyna!\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 3
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.problem.questions[0].answer === null || _vm.$v.$store.state.form.problem.$invalid || _vm.$store.state.form.problem.questions[1].answer === null || _vm.$store.state.form.problem.questions[2].answer === null || _vm.$store.state.form.problem.description === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 5
      }
    }
  }, [_vm._v("\n                        Frekari\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.$store.state.form.problem.questions), function(question, index) {
    return _c('div', {
      key: question.question,
      staticClass: "line",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('label', [_vm._v("\n                            " + _vm._s(question.questionIS) + "\n                        ")]), _vm._v(" "), (question.slug === 'restart') ? _c('div', [_vm._m(11, true)]) : _vm._e()]), _vm._v(" "), (index === 2) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true;
          _vm.showBlinkHelper = true
        }
      }
    }, [_vm._v("\n                            Já\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.$store.state.form.problem.questions[index].extra = null
        }
      }
    }, [_vm._v("\n                            Nei\n                        ")])]) : (index === 3) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Já\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.showRestartHelper = true
        }
      }
    }, [_vm._v("\n                            Nei\n                        ")])]) : _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Já\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false
        }
      }
    }, [_vm._v("\n                            Nei\n                        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.problem.description),
      expression: "$store.state.form.problem.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Beskrivelse av problem",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.$store.state.form.problem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.problem, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper mts"
  }, [_c('validation-messages', {
    attrs: {
      "data": _vm.$v.$store.state.form.problem.description,
      "show": true
    }
  }), _vm._v(" "), (_vm.$store.state.form.problem.description) ? _c('div', {
    staticClass: "validator",
    class: {
      'validated': _vm.$store.state.form.problem.description.length > 19
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.problem.description.length) + " / 20\n                            ")]) : _vm._e()], 1)])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 5),
      expression: "currentStep === 5"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 4
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.warranty.underWarranty === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationMonth === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationYear === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 6
      }
    }
  }, [_vm._v("\n                        Frekari\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === true
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = true
      }
    }
  }, [_vm._v("\n                            Já\n                        ")]), _vm._v(" "), _c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === false
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = false
      }
    }
  }, [_vm._v("\n                            Nei\n                        ")])])]), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty === true) ? _c('div', {
    staticClass: "line"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationMonth),
      expression: "$store.state.form.warranty.installationMonth"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.months), function(month) {
    return _c('option', {
      key: month
    }, [_vm._v("\n                                " + _vm._s(month) + "\n                            ")])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationYear),
      expression: "$store.state.form.warranty.installationYear"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year
    }, [_vm._v("\n                                " + _vm._s(year) + "\n                            ")])
  }), 0)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 6),
      expression: "currentStep === 6"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 5
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 7
      }
    }
  }, [_vm._v("\n                        Frekari\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('file-upload', {
    attrs: {
      "intro": "Valfrjálst - Hladdu upp myndum, myndskeiðum eða öðrum viðeigandi skrám ef beðið er um það<br><br><b style='font-family:AvenirHeavyOblique;'>ATHUGIÐ</b>&nbsp;&nbsp;Ef Quooker þinn hefur hljóð, munum við biðja um myndband<br><b style='font-family:AvenirHeavyOblique;color:#fff;'>ATHUGIÐ</b>&nbsp;&nbsp;Ef Quookerinn þinn hefur orðið fyrir líkamlegum skemmdum biðjum við um myndir",
      "singleFileUploaded": "skrá hlaðið upp",
      "multipleFilesUploaded": "skrár hlaðið upp",
      "noFilesUploaded": "Engum skrám hlaðið upp",
      "addFilesButton": "Bæta við skrám",
      "remove": "Fjarlægur"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 7),
      expression: "currentStep === 7"
    }],
    staticClass: "step"
  }, [(_vm.currentStep === 7) ? _c('div', {
    staticStyle: {
      "display": "none",
      "overflow-y": "auto",
      "height": "500px",
      "position": "absolute",
      "z-index": "999",
      "background": "#f8f9fc",
      "width": "100%"
    },
    attrs: {
      "id": "emailMockup"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "width": "400px",
      "margin": "25px auto"
    }
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.icelandic)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Mikilvægt!")]), _vm._v(" Ef þú hefur einhverjar spurningar skaltu svara þessum tölvupósti.\n                        "), _c('br'), _c('br'), _vm._v("\n                        Hér að neðan finnur þú afrit af innslögðu upplýsingum þínum.\n                        "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "summary",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "border": "1px solid #ccc"
    }
  }, [_c('div', [_c('b', [_vm._v("Málsnúmer")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.meta.id) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Ílát")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.container.serial !== null) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.container.serial.toUpperCase()) + " - " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.cube.serial !== null) ? _c('div', [_c('b', [_vm._v("CUBE")]), _vm._v(" "), _c('br'), _vm._v("\n                            Raðnúmer: " + _vm._s(_vm.$store.state.form.cube.serial) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.cube.serial !== null) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', [_c('b', [_vm._v("Krani")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.validatedFaucet.title) + "\n                            "), (_vm.$store.state.form.faucet.meta !== null) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.$store.state.form.faucet.meta) + ")\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.surface) + "\n                            ")]), _vm._v(" "), (_vm.$store.state.form.faucet.serial !== null) ? _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.serial) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Spurningar")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.$store.state.form.problem.questions), function(q) {
    return _c('div', [_vm._v("\n                                " + _vm._s(q.questionIS) + ":\n                                "), (q.answer) ? _c('b', [_vm._v("\n                                    Já\n                                ")]) : _c('b', [_vm._v("Nei")]), _vm._v(" "), (q.extra) ? _c('b', [_vm._v("\n                                    (" + _vm._s(q.extra) + ")\n                                ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Lýsing á vandamáli")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.problem.description) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Ábyrgð")]), _vm._v(" "), _c('br'), _vm._v("\n                            Er varan yngri en 24 mánaða gömul?\n                            "), (_vm.$store.state.form.warranty.underWarranty) ? _c('b', [_vm._v("Ja")]) : _c('b', [_vm._v("Nei")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty) ? _c('span', [_vm._v("\n                                Uppsetningardagur:\n                                "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.warranty.installationMonth) + " " + _vm._s(_vm.$store.state.form.warranty.installationYear))])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Samskiptaupplýsingar")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.firstname) + "\n                            " + _vm._s(_vm.$store.state.form.contact.lastname) + "\n                            "), _c('br'), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('span', [_vm._v("\n                                Fyrirtæki: " + _vm._s(_vm.$store.state.form.contact.company) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('br') : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.phone) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.email) + "\n                            "), _c('br'), _vm._v(" "), (_vm.fullAddress !== null) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm.fullAddress) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Viðhengi")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.attachments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.$store.state.form.attachments), function(attachment) {
    return _c('li', {
      key: attachment.name
    }, [_c('a', {
      attrs: {
        "href": attachment.path
      }
    }, [_vm._v("\n                                            " + _vm._s(attachment.name) + "\n                                        ")])])
  }), 0)]) : _c('div', [_vm._v("\n                                Engum skrám hlaðið upp\n                            ")])])]), _vm._v(" "), _vm._m(17)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 6
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Til baka\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.loading) ? _c('span', [_c('i', {
    staticClass: "fal fa-spinner fa-spin"
  }), _vm._v("\n                         \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.loading || _vm.$v.$store.state.form.contact.$invalid || _vm.$store.state.form.terms.accepted === false
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n                        Senda\n                        "), _c('i', {
    staticClass: "fal fa-envelope"
  })])])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line three-columns"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.firstname),
      expression: "$store.state.form.contact.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.firstname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left middle"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.lastname),
      expression: "$store.state.form.contact.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.lastname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Viðskipti (valfrjálst)\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.company),
      expression: "$store.state.form.contact.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.email),
      expression: "$store.state.form.contact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.email
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.phone),
      expression: "$store.state.form.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.phone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line address-field"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "calc(100% + 30px)"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-sm-6"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "2f3b92h83nfuiei9he",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-sm-2"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipcode),
      expression: "zipcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-4"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left fw terms"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.terms.accepted),
      expression: "$store.state.form.terms.accepted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.form.terms.accepted) ? _vm._i(_vm.$store.state.form.terms.accepted, null) > -1 : (_vm.$store.state.form.terms.accepted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$store.state.form.terms.accepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.form.terms, "accepted", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(26)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })])])]), _vm._v(" "), (_vm.currentStep === 8) ? _c('div', {
    staticClass: "step"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.norwegian)
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                Málsnúmer: "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.meta.id))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Við höfum sent þér tölvupóst þar sem málsnúmer þitt hefur verið skráð. Ef þú færð ekki þennan tölvupóst innan klukkustundar skaltu athuga hvort hann hafi endað sem ruslpóstur. Ef það er ekki til staðar, vinsamlegast hafðu samband við okkur í síma.\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.currentStep !== 7) ? _c('div', {
    staticClass: "q-progress-bar"
  }, [_c('div', {
    staticClass: "line",
    style: ('width:' + ((16.66 * _vm.currentStep) - 16.66) + '%;')
  }), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 1
    }
  }, [_vm._v("\n            1\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 2
    }
  }, [_vm._v("\n            2\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 3
    }
  }, [_vm._v("\n            3\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 4
    }
  }, [_vm._v("\n            4\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 5
    }
  }, [_vm._v("\n            5\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 6
    }
  }, [_vm._v("\n            6\n        ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Hafðu samband (IS)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                         \n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                Til að geta aðstoðað þig á sem bestan hátt þurfum við raðnúmer vörunnar sem fyrirspurn þín snýr að. Þú verður alltaf að slá inn raðnúmer ílátsins, jafnvel þótt beiðnin sé um blöndunartæki.\n                "), _c('br'), _c('br'), _vm._v("\n                Ef þú velur að slá inn raðnúmer allra vara getum við veitt þér bestu, hröðustu og öruggustu þjónustuna og stuðninginn.\n                "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Sláðu inn raðnúmer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        1 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Raðnúmer á ílátinu þínu "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Raðnúmer blöndunartækisins þíns "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Veldu krana\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        2 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Veldu yfirborð\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        3 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink two"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    2 blikk\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinktwo.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink four"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    4 blikk\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkfour.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink threeplusone"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    3 + 1 blikk\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkthreeplusone.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vandamál / orsök\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        4 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quooker.no/faq-generelt",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle fa-fw"
  }), _vm._v("\n                                Hvernig á að baka Quookerinn þinn\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Lýstu vandamálinu\n                        ")]), _vm._v("\n                        Lýstu vandamálinu eða spurningunni á reitnum hér. Ef um villu er að ræða er mikilvægt að útskýra einkennin. Hvað ertu að gera og hvað er að gerast?\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Ábyrgð\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        5 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Er varan yngri en 24 mánaða gömul?\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Uppsetningardagur\n                        ")]), _vm._v("\n                        Veldu mánuð og ár fyrir uppsetningu\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Hengdu skrár\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        6 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outro",
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _c('br'), _vm._v("\n                        Með bestu kveðjum\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Quooker Island")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Samskiptaupplýsingar\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        6 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Fyrsta nafn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Eftirnafn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Tölvupóstur "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Sími "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Heimilisfang "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Póstnúmer. "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Bærinn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                            Ég hef lesið og samþykkt Quookers "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/privatlivspolitik",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("persónuvernd og viðskiptaskilyrði")]), _vm._v(" "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        SENT - Þakka þér fyrir fyrirspurn þína\n                    ")])])])
}]}

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show || _vm.data.$model !== '') ? _c('div', {
    staticClass: "validation-messages"
  }, [(_vm.data.$params.required && !_vm.data.required && _vm.data.length > 0) ? _c('div', {
    staticClass: "invalid-feedback v-required"
  }, [_vm._v("\n        Required\n    ")]) : _vm._e(), _vm._v(" "), (_vm.data.$params.minLength && _vm.data.$params.maxLength && _vm.data.$params.minLength.min === _vm.data.$params.maxLength.max) ? _c('div', [(!_vm.data.minLength || !_vm.data.maxLength) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("\n            Feltet skal være " + _vm._s(_vm.data.$params.minLength.min) + " karakterer\n        ")]) : _vm._e()]) : _c('div', [(_vm.show || _vm.data.$params.minLength && !_vm.data.minLength) ? _c('div', {
    staticClass: "invalid-feedback v-minlength"
  }, [_vm._v("\n            Feltet skal være min. " + _vm._s(_vm.data.$params.minLength.min) + " karakterer\n        ")]) : _vm._e(), _vm._v(" "), (_vm.data.$params.maxLength && !_vm.data.maxLength) ? _c('div', {
    staticClass: "invalid-feedback v-maxlength"
  }, [_vm._v("\n            Feltet må max være " + _vm._s(_vm.data.$params.maxLength.max) + " karakterer\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.data.$params.numeric && !_vm.data.numeric) ? _c('div', {
    staticClass: "invalid-feedback v-numeric"
  }, [_vm._v("\n        Feltet må kun inneholde tall\n    ")]) : _vm._e(), _vm._v(" "), (_vm.data.$params.alpha && !_vm.data.alpha) ? _c('div', {
    staticClass: "invalid-feedback v-alpha"
  }, [_vm._v("\n        Feltet må kun inneholde bokstaver og tal\n    ")]) : _vm._e(), _vm._v(" "), (_vm.data.$params.alphaNum && !_vm.data.alphaNum) ? _c('div', {
    staticClass: "invalid-feedback v-alphanum"
  }, [_vm._v("\n        Feltet må kun inneholde bokstaver, tegn og tall\n    ")]) : _vm._e(), _vm._v(" "), (_vm.data.$params.email && !_vm.data.email) ? _c('div', {
    staticClass: "invalid-feedback v-email"
  }, [_vm._v("\n        Ugyldigt e-mail format\n    ")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-upload"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "attachment-input"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.$store.state.form.attachments.length === 1) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.$store.state.form.attachments.length) + "\n                " + _vm._s(_vm.singleFileUploaded) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.attachments.length > 1) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.$store.state.form.attachments.length) + "\n                " + _vm._s(_vm.multipleFilesUploaded) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('form', {
    ref: "attachmentform",
    staticClass: "attachments-form"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file",
      "multiple": "",
      "accept": "image/*,video/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    },
    on: {
      "change": _vm.uploadFile
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "file"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.addFilesButton) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "files-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "file-loader"
  }, [_c('i', {
    staticClass: "fal fa-circle-notch fa-spin"
  })]), _vm._v(" "), _vm._l((_vm.$store.state.form.attachments), function(attachment, index) {
    return _c('div', {
      key: attachment.path,
      staticClass: "file"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "main"
    }, [_vm._v("\n                    " + _vm._s(attachment.name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "size"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("tomb")(attachment.size)) + "    \n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          return _vm.removeAttachment(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.remove) + "\n            ")])])
  }), _vm._v(" "), (_vm.$store.state.form.attachments.length === 0) ? _c('div', {
    staticClass: "no-files"
  }, [_vm._v("\n            " + _vm._s(_vm.noFilesUploaded) + "\n        ")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offline-wrapper"
  }, [_c('div', {
    staticClass: "offline-inner"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  })]), _vm._v(" "), _c('h1', [_vm._v("Hov!")]), _vm._v(" "), _c('h3', [_vm._v("Du har mistet din internetforbindelse")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("Vi kunne ikke registrere en aktiv internetforbindelse i din browser. Applikationen kan derfor ikke indlæses. Prøv at tjekke din forbindelse og opdater siden igen.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Genindlæs siden")])])])])])
}]}

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "info-message"
  }, [_vm._v("\n            Scroll evt. for at se alle felter\n        ")]), _vm._v(" "), (_vm.showEmailChooser) ? _c('div', {
    staticClass: "email-chooser"
  }, [_vm._v("\n            Send test e-mail til:\n            "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.default.email),
      expression: "$store.state.form.default.email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.default.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.default, "email", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === -1),
      expression: "currentStep === -1"
    }],
    staticClass: "step"
  }, [_vm._v("\n            Our form is currently unavailable.\n            "), _c('br'), _c('br'), _vm._v("\n            We expect to be up and running again by 8PM today.\n            "), _c('br'), _c('br'), _vm._v("\n            Sorry for the inconvenience.\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    staticClass: "swedish-link",
    staticStyle: {
      "display": "inline-flex",
      "align-items": "center",
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.goToSwedishForm()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sweden.png",
      "height": "16"
    }
  }), _vm._v(" \n                        Svensk kunde?\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "swedish-link",
    staticStyle: {
      "display": "inline-flex",
      "align-items": "center"
    },
    on: {
      "click": function($event) {
        return _vm.goToFaroeIslandsForm()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/faroe_islands.png",
      "height": "16"
    }
  }), _vm._v(" \n                        Færøsk kunde?\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right",
    staticStyle: {
      "display": "none"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1;
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 1),
      expression: "currentStep === 1"
    }],
    staticClass: "step"
  }, [(_vm.showCubeErrorcodesModal) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [(_vm.cubeErrorPage === 1) ? _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Drejer din henvendelse sig om CUBE?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.cubeErrorPage = 2
      }
    }
  }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2;
        _vm.showCubeErrorcodesModal = false;
      }
    }
  }, [_vm._v("\n                            Nej, gå videre\n                        ")])])]) : _vm._e(), _vm._v(" "), (_vm.cubeErrorPage === 2) ? _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Viser din CUBE en af følgende fejlkoder?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Tryk på fejlkoden herunder. Hvis du ikke ser en fejlkode, kan du blot fortsætte.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "padding": "15px 0"
    }
  }, _vm._l((_vm.cubeErrorcodes), function(errorcode) {
    return _c('button', {
      staticStyle: {
        "width": "unset",
        "margin": "0 5px"
      },
      on: {
        "click": function($event) {
          _vm.cubeErrorPage = 3;
          _vm.selectedCubeErrorcode = errorcode;
          _vm.$store.state.form.problem.description = "CUBE fejlkode " + (errorcode.code) + " - " + (errorcode.description)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(errorcode.code) + "\n                        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2;
        _vm.showCubeErrorcodesModal = false;
      }
    }
  }, [_vm._v("\n                            Nej, gå videre\n                        ")])])]) : _vm._e(), _vm._v(" "), (_vm.cubeErrorPage === 3 && _vm.selectedCubeErrorcode) ? _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        CUBE fejlkode " + _vm._s(_vm.selectedCubeErrorcode.code) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        " + _vm._s(_vm.selectedCubeErrorcode.description) + "\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#C80236"
    }
  }, [_vm._v("Mulig løsning")]), _c('br'), _vm._v("\n                        " + _vm._s(_vm.selectedCubeErrorcode.solution) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep++;
        _vm.showCubeErrorcodesModal = false;
        _vm.cubeErrorPage = 1
      }
    }
  }, [_vm._v("\n                            Gå videre\n                        ")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showEContainerModal) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === '') ? _c('span', [_vm._v("\n                        Udfyld alle felter markeret med \""), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")]), _vm._v("\" for at gå videre \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === ''
    },
    on: {
      "click": function($event) {
        (_vm.$store.state.form.cube.serial ? (_vm.showCubeErrorcodesModal = true) : _vm.currentStep = 2);
        _vm.setPixel('Vaelg hane')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(4), _vm._v("\n                        Serienummeret finder du på et mærkat på siden af beholderen. Hvis du er i tvivl, se\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showSerialHelper = !_vm.showSerialHelper
      }
    }
  }, [_vm._v("her")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSerialHelper),
      expression: "showSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "max-height": "240px",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-beholder.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.container.serial),
      expression: "$store.state.form.container.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.container.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.container, "serial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mts"
  }, [(_vm.$store.state.form.validatedContainer !== null && _vm.$store.state.form.container.serial.length > 5) ? _c('span', {
    staticClass: "green"
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _c('span', [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length > 0) ? _c('span', {
    staticClass: "red"
  }, [_vm._v("\n                                    " + _vm._s(_vm.faucetSerial ? 'Det ser ud til, at du er ved at indtaste serienummeret på din hane og ikke din beholder. Skriv venligst serienummeret på din beholder i dette felt for at gå videre.' : 'Intet match fundet') + "\n                                ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(5), _vm._v("\n                        Du finder serienummeret på den sorte ledning fra armaturet. Hvis du er i tvivl, se\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = !_vm.showTapSerialHelper
      }
    }
  }, [_vm._v("her")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTapSerialHelper),
      expression: "showTapSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-hane.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.faucet.serial),
      expression: "$store.state.form.faucet.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.faucet.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.faucet, "serial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Serienummer på din CUBE\n                        ")]), _vm._v("\n                        Hvis du har en CUBE køleenhed. Serienummeret findes på et klistermærke på enten forsiden eller bagsiden af CUBE.\n                        Hvis du er i tvivl, se\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showCubeSerialHelper = !_vm.showCubeSerialHelper
      }
    }
  }, [_vm._v("her")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCubeSerialHelper),
      expression: "showCubeSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-cube.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showCubeSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.cube.serial),
      expression: "$store.state.form.cube.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.cube.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.cube, "serial", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }],
    staticClass: "step"
  }, [(_vm.showNordicChooser) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Twintaps eller single tap Nordic?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Twintaps består af både en kogende vandhane og et almindeligt blandingsbatteri fra Quooker.\n                        Single tap er når du kun har en kogende vandhane fra Quooker.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Twintaps')
      }
    }
  }, [_vm._v("\n                            Twintaps\n                        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Single Tap')
      }
    }
  }, [_vm._v("\n                            Single tap\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.validatedFaucet === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 3;
        _vm.setPixel('Vaelg overflade')
      }
    }
  }, [(_vm.$store.state.form.validatedFaucet === null) ? _c('span', [_vm._v("\n                            Hane skal vælges\n                        ")]) : _c('span', [_vm._v("\n                            Videre\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "faucets"
  }, _vm._l((_vm.sortedFaucets), function(faucet) {
    return _c('div', {
      key: faucet.title,
      staticClass: "faucet",
      class: {
        'selected': _vm.$store.state.form.validatedFaucet !== null && _vm.$store.state.form.validatedFaucet.title === faucet.title
      },
      on: {
        "click": function($event) {
          return _vm.validateFaucet(faucet)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": faucet.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(faucet.title) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n                            " + _vm._s(faucet.description) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 3),
      expression: "currentStep === 3"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.faucet.surface === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 4;
        _vm.setPixel('Problem aarsag')
      }
    }
  }, [(_vm.$store.state.form.faucet.surface === null) ? _c('span', [_vm._v("\n                            Overflade skal vælges\n                        ")]) : _c('span', [_vm._v("\n                            Videre\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "surfaces"
  }, _vm._l((_vm.sortedSurfaces), function(surface) {
    return _c('div', {
      key: surface.title,
      staticClass: "surface",
      class: {
        'selected': _vm.$store.state.form.faucet.surface === surface.title
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.faucet.surface = surface.title
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "sm",
      attrs: {
        "src": surface.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(surface.title) + "\n                        ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 4),
      expression: "currentStep === 4"
    }],
    staticClass: "step"
  }, [(_vm.showRestartHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Sådan nulstiller du din Quooker\n                    ")]), _vm._v("\n                    Mange fejl kan med succes afhjælpes, med en simpel genstart og nulstilling af softwaren i Quookeren.\n                    "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("\n                        Se her hvordan du genstarter din Quooker korrekt")]), _vm._v(".\n                    "), _c('br'), _c('br'), _vm._v("\n                    Det er ikke nok bare at hive stikket ud!\n                    "), _c('br'), _c('br'), _vm._v("\n                    Vi anbefaler du prøver at genstarte din Quooker korrekt nogle gange, inden du kontakter os.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        Luk vindue\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.showBlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showBlinkHelper = false;
        _vm.$store.state.form.problem.questions[2].answer = null
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Hvordan blinker din Quooker?\n                    ")]), _vm._v("\n                    Hvis Quookeren opdager en fejl/uregelmæssighed vil lyset i hanen og på beholderen blinke i et fast mønster.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "90%"
    }
  }, [_vm._v("OBS! I nogle tilfælde er det kun beholderen der blinker, tjek derfor altid både hanen og beholderen.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option-wrapper"
  }, [_c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '2 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '4 blink';
        _vm.showBlinkHelper = false;
        _vm.show4BlinkHelper = true
      }
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '3 + 1 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(10)])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "option last",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = 'Andet / ved ikke';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._v("\n                            Andet / ved ikke\n                        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.show4BlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "max-height": "90%",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        4 blink\n                    ")]), _vm._v("\n                    4 blink på hane, eller beholder, betyder at softwaren i din Quooker registrerer en fejl i forbindelse med temperaturmålingen i din Quooker.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#C80236"
    }
  }, [_vm._v("Tips!")]), _c('br'), _vm._v("\n                    Fejlen kan ofte nulstilles, ved at give beholderen et \"kuldechok\""), _c('br'), _c('br'), _vm._v("\n                    Det gøres ved at slukke på beholderens top og tappe alt kogende vand af beholderen. Når vandet ikke længere er kogende, lader man vandet løbe i yderligere 2 minutter således at vandet er helt koldt."), _c('br'), _c('br'), _vm._v("\n                    Derefter skal du følge vores almindelige "), _c('a', {
    staticClass: "main",
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "target": "_blank"
    }
  }, [_vm._v("nulstillingsprocedure")]), _vm._v(", hvorefter beholderen burde være klar til brug efter ca. 20 minutter."), _c('br'), _c('br'), _vm._v("\n                    Manøvren kan være nødvendig at gentage et par gange"), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "unset",
      "outline": "none",
      "background": "#C80236",
      "color": "#fff",
      "border": "1px solid #e6003f!important",
      "padding": "5px 10px",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        OK, det prøver jeg!\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 3
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.problem.questions[0].answer === null || _vm.$v.$store.state.form.problem.$invalid || _vm.$store.state.form.problem.questions[1].answer === null || _vm.$store.state.form.problem.questions[2].answer === null || _vm.$store.state.form.problem.description === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 5;
        _vm.setPixel('Garanti')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.$store.state.form.problem.questions), function(question, index) {
    return _c('div', {
      key: question.question,
      staticClass: "line",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('label', [_vm._v("\n                            " + _vm._s(question.question) + "\n                        ")]), _vm._v(" "), (question.slug === 'restart') ? _c('div', [_vm._m(12, true)]) : _vm._e()]), _vm._v(" "), (index === 2) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true;
          _vm.showBlinkHelper = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.$store.state.form.problem.questions[index].extra = null
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])]) : (index === 3) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.showRestartHelper = true
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])]) : _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.problem.description),
      expression: "$store.state.form.problem.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Beskrivelse af problem",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.$store.state.form.problem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.problem, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper mts"
  }, [_c('validation-messages', {
    attrs: {
      "data": _vm.$v.$store.state.form.problem.description,
      "show": true
    }
  }), _vm._v(" "), (_vm.$store.state.form.problem.description) ? _c('div', {
    staticClass: "validator",
    class: {
      'validated': _vm.$store.state.form.problem.description.length > 19
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.problem.description.length) + " / 20\n                            ")]) : _vm._e()], 1)])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 5),
      expression: "currentStep === 5"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 4
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.warranty.underWarranty === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationMonth === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationYear === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 6;
        _vm.setPixel('Vedhæft filer')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === true
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = true
      }
    }
  }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === false
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = false
      }
    }
  }, [_vm._v("\n                            Nej\n                        ")])])]), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty === true) ? _c('div', {
    staticClass: "line"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationMonth),
      expression: "$store.state.form.warranty.installationMonth"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.months), function(month) {
    return _c('option', {
      key: month
    }, [_vm._v("\n                                " + _vm._s(month) + "\n                            ")])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationYear),
      expression: "$store.state.form.warranty.installationYear"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year
    }, [_vm._v("\n                                " + _vm._s(year) + "\n                            ")])
  }), 0)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 6),
      expression: "currentStep === 6"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 5
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 7;
        _vm.setPixel('Kontaktinformationer')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('file-upload', {
    attrs: {
      "intro": "Valgfrit - Upload billeder, video eller andre relevante filer, hvis du er blevet bedt om dette.<br><br><b style='font-family:AvenirHeavyOblique;'>OBS</b>&nbsp;&nbsp;Hvis din Quooker har mislyde, skal vi bede om en video<br><b style='font-family:AvenirHeavyOblique;color:#fff;'>OBS</b>&nbsp;&nbsp;Hvis din Quooker har fået en fysisk skade, skal vi bede om billeder",
      "singleFileUploaded": "fil uploadet",
      "multipleFilesUploaded": "filer uploadet",
      "noFilesUploaded": "Ingen filer uploadet",
      "addFilesButton": "Tilføj fil(er)",
      "remove": "Fjern"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 7),
      expression: "currentStep === 7"
    }],
    staticClass: "step"
  }, [(_vm.showAddressModal) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Validering af adresse\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Vi beklager, men der skete en fejl ved validering af din adresse. Udfyld venligst dette felt med din fulde adresse for at sende formularen.\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.address),
      expression: "$store.state.form.contact.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Indtast din fulde adresse"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.submitManualAddress()
      }
    }
  }, [_vm._v("Send")])])])]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 7) ? _c('div', {
    staticStyle: {
      "display": "none",
      "position": "absolute",
      "z-index": "999",
      "background": "#f8f9fc",
      "width": "100%"
    },
    attrs: {
      "id": "emailMockup"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "width": "400px",
      "margin": "25px auto"
    }
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.danish)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Vigtigt!")]), _vm._v(" Har du spørgsmål bedes du besvare denne mail.\n                        "), _c('br'), _c('br'), _vm._v("\n                        Herunder finder du en kopi af dine indtastede oplysninger:\n                        "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "summary",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "border": "1px solid #ccc",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    }
  }, [_c('div', [_c('b', [_vm._v("Sagsnummer")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.meta.id) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Beholder")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.container.serial !== null) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.container.serial.toUpperCase()) + " - " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.cube.serial !== null) ? _c('div', [_c('b', [_vm._v("CUBE")]), _vm._v(" "), _c('br'), _vm._v("\n                            Serienummer: " + _vm._s(_vm.$store.state.form.cube.serial) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.cube.serial !== null) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', [_c('b', [_vm._v("Hane")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.validatedFaucet.title) + "\n                            "), (_vm.$store.state.form.faucet.meta !== null) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.$store.state.form.faucet.meta) + ")\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.surface) + "\n                            ")]), _vm._v(" "), (_vm.$store.state.form.faucet.serial !== null) ? _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.serial) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Spørgsmål")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.$store.state.form.problem.questions), function(q) {
    return _c('div', [_vm._v("\n                                " + _vm._s(q.question) + ":\n                                "), (q.answer) ? _c('b', [_vm._v("\n                                    Ja\n                                ")]) : _c('b', [_vm._v("Nej")]), _vm._v(" "), (q.extra) ? _c('b', [_vm._v("\n                                    (" + _vm._s(q.extra) + ")\n                                ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Beskrivelse af problemet")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.problem.description) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Garanti")]), _vm._v(" "), _c('br'), _vm._v("\n                            Er produktet under 24 måneder?\n                            "), (_vm.$store.state.form.warranty.underWarranty) ? _c('b', [_vm._v("Ja")]) : _c('b', [_vm._v("Nej")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty) ? _c('span', [_vm._v("\n                                Installationsdato:\n                                "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.warranty.installationMonth) + " " + _vm._s(_vm.$store.state.form.warranty.installationYear))])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Kontaktoplysninger")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.firstname) + "\n                            " + _vm._s(_vm.$store.state.form.contact.lastname) + "\n                            "), _c('br'), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('span', [_vm._v("\n                                Firma: " + _vm._s(_vm.$store.state.form.contact.company) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('br') : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.phone) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.email) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.validatedAddress) + "\n                            "), (_vm.addressIssues) ? _c('div', [_c('b', [_vm._v("\n                                    OBS! Adressen er ikke valideret med DAWA.\n                                ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Vedhæftninger")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.attachments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.$store.state.form.attachments), function(attachment) {
    return _c('li', {
      key: attachment.name
    }, [_c('a', {
      attrs: {
        "href": attachment.path
      }
    }, [_vm._v("\n                                            " + _vm._s(attachment.name) + "\n                                        ")])])
  }), 0)]) : _c('div', [_vm._v("\n                                Ingen filer uploadet\n                            ")])])]), _vm._v(" "), _vm._m(18)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 6
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.loading) ? _c('span', [_c('i', {
    staticClass: "fal fa-spinner fa-spin"
  }), _vm._v("\n                         \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.loading || _vm.$v.$store.state.form.contact.$invalid || _vm.$store.state.form.terms.accepted === false
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n                        Send\n                        "), _c('i', {
    staticClass: "fal fa-envelope"
  })])])]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line three-columns"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.firstname),
      expression: "$store.state.form.contact.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.firstname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left middle"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.lastname),
      expression: "$store.state.form.contact.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.lastname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Firma (valgfri)\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.company),
      expression: "$store.state.form.contact.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.email),
      expression: "$store.state.form.contact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.email
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.phone),
      expression: "$store.state.form.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.phone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line address-field"
  }, [_c('div', {
    staticClass: "left fw autocomplete-container"
  }, [_vm._m(24), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "none!important"
    }
  }, [_vm._v("\n                            A\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.address),
      expression: "$store.state.form.contact.address"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dawa-autocomplete-input",
      "type": "text",
      "disabled": _vm.$store.state.form.contact.validatedAddress !== null,
      "name": "2f3b92h83nfuiei9h",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mts"
  }, [(_vm.$store.state.form.contact.validatedAddress === null) ? _c('span', [_vm._v("\n                                Vælg adresse fra listen ved indtastning\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.contact.validatedAddress !== null) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.resetAddress()
      }
    }
  }, [_vm._v("\n                                Klik her, hvis du vil vælge en anden adresse\n                            ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left fw terms"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.terms.accepted),
      expression: "$store.state.form.terms.accepted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.form.terms.accepted) ? _vm._i(_vm.$store.state.form.terms.accepted, null) > -1 : (_vm.$store.state.form.terms.accepted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$store.state.form.terms.accepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.form.terms, "accepted", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(25)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })])])]), _vm._v(" "), (_vm.currentStep === 8) ? _c('div', {
    staticClass: "step"
  }, [_vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.danish)
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                Sagsnummer: "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.meta.id))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Vi har sendt dig en mail hvor dit sagsnummer også er noteret. Modtager du ikke denne email inden for en time, så tjek først din spam-mappe og kontakt os dernæst evt. telefonisk i stedet.\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.currentStep !== 7) ? _c('div', {
    staticClass: "q-progress-bar"
  }, [_c('div', {
    staticClass: "line",
    style: ('width:' + ((16.66 * _vm.currentStep) - 16.66) + '%;')
  }), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 1
    }
  }, [_vm._v("\n            1\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 2
    }
  }, [_vm._v("\n            2\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 3
    }
  }, [_vm._v("\n            3\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 4
    }
  }, [_vm._v("\n            4\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 5
    }
  }, [_vm._v("\n            5\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 6
    }
  }, [_vm._v("\n            6\n        ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Kontaktformular\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                         \n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                Kære kunde,\n                "), _c('br'), _c('br'), _vm._v("\n                Denne kontaktformular vedligeholdes ikke længere.\n                "), _c('br'), _c('br'), _vm._v("\n                Du finder nu al hjælp, vejledning og mulighed for kontakt i vores selvbetjening.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#C80236",
      "font-family": "'AvenirHeavyOblique'"
    },
    attrs: {
      "href": "https://selvbetjening.quooker.dk?utm_source=qservice&utm_medium=referral&utm_campaign=serviceform",
      "target": "_blank"
    }
  }, [_vm._v("Gå til selvbetjening →")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Kære Quooker-kunde\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Vi har vigtig info om din beholder/hane, der betyder at du i stedet skal læse nærmere "), _c('a', {
    staticStyle: {
      "color": "#C80236",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://quooker.dk/service/udfasning-beholder"
    }
  }, [_vm._v("her")]), _vm._v(" for at komme videre.\n                        "), _c('br'), _c('br'), _vm._v("\n                        Mvh. Quooker\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "30px",
      "object-fit": "contain"
    },
    attrs: {
      "src": __webpack_require__(335)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Angiv serienummer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        1 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Serienummer på din beholder "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Serienummer på din hane "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vælg hane\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        2 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vælg overflade\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        3 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink two"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    2 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinktwo.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink four"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    4 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkfour.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink threeplusone"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    3 + 1 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkthreeplusone.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Problem / årsag\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        4 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fal fa-video fa-fw"
  }), _vm._v("\n                                Sådan nulstiller du din Quooker\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Beskrivelse af problemet\n                        ")]), _vm._v("\n                        Beskriv dit problem eller spørgsmål i feltet her. Ved fejl er det vigtigt at uddybe symptomet; Hvad gør du og hvad sker der?\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Garanti\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        5 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Er produktet under 24 måneder gammelt?\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Installationsdato\n                        ")]), _vm._v("\n                        Vælg måned og år din Quooker blev installeret\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vedhæft filer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        6 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outro",
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _c('br'), _vm._v("\n                        Med venlig hilsen\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Quooker Skandinavien A/S")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Kontaktinformationer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        7 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Fornavn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Efternavn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            E-mail "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Telefon "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Adresse "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                            Jeg har læst og accepterer Quookers "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/privatlivspolitik",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("privatlivs- og forretningsbetingelser")]), _vm._v(" "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        INDSENDT - Tak for din henvendelse\n                    ")])])])
}]}

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "info-message"
  }, [_vm._v("\n            Bla om nødvendig for å se alle feltene\n        ")]), _vm._v(" "), (_vm.showEmailChooser) ? _c('div', {
    staticClass: "email-chooser"
  }, [_vm._v("\n            Send test e-mail til:\n            "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultToEmail),
      expression: "defaultToEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.defaultToEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.defaultToEmail = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }],
    staticClass: "step"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    staticClass: "swedish-link",
    staticStyle: {
      "display": "inline-flex",
      "align-items": "center",
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.goToDanishForm()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "border": "1px solid #fff"
    },
    attrs: {
      "src": "/static/img/denmark.png",
      "height": "16"
    }
  }), _vm._v(" \n                        Dansk kunde?\n                    ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 1),
      expression: "currentStep === 1"
    }],
    staticClass: "step"
  }, [(_vm.showCubeErrorcodesModal) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [(_vm.cubeErrorPage === 1) ? _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Handler din forespørsel om CUBE?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.cubeErrorPage = 2
      }
    }
  }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2;
        _vm.showCubeErrorcodesModal = false;
      }
    }
  }, [_vm._v("\n                            Nei, fortsett\n                        ")])])]) : _vm._e(), _vm._v(" "), (_vm.cubeErrorPage === 2) ? _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Viser CUBE en av følgende feilkoder?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Trykk på feilkoden nedenfor. Hvis du ikke ser en feilkode, kan du bare fortsette.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "padding": "15px 0"
    }
  }, _vm._l((_vm.cubeErrorcodes), function(errorcode) {
    return _c('button', {
      staticStyle: {
        "width": "unset",
        "margin": "0 5px"
      },
      on: {
        "click": function($event) {
          _vm.cubeErrorPage = 3;
          _vm.selectedCubeErrorcode = errorcode;
          _vm.$store.state.form.problem.description = "CUBE fejlkode " + (errorcode.code) + " - " + (errorcode.description)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(errorcode.code) + "\n                        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2;
        _vm.showCubeErrorcodesModal = false;
      }
    }
  }, [_vm._v("\n                            Nei, fortsett\n                        ")])])]) : _vm._e(), _vm._v(" "), (_vm.cubeErrorPage === 3 && _vm.selectedCubeErrorcode) ? _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        CUBE feilkode " + _vm._s(_vm.selectedCubeErrorcode.code) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        " + _vm._s(_vm.selectedCubeErrorcode.description) + "\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#C80236"
    }
  }, [_vm._v("Mulig løsning")]), _c('br'), _vm._v("\n                        " + _vm._s(_vm.selectedCubeErrorcode.solution) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep++;
        _vm.showCubeErrorcodesModal = false;
        _vm.cubeErrorPage = 1
      }
    }
  }, [_vm._v("\n                            Fortsett\n                        ")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === '') ? _c('span', [_vm._v("\n                        Fyll ut alle feltene merket med \""), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")]), _vm._v("\" for å fortsette\n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === ''
    },
    on: {
      "click": function($event) {
        (_vm.$store.state.form.cube.serial ? (_vm.showCubeErrorcodesModal = true) : _vm.currentStep = 2)
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(4), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showSerialHelper = !_vm.showSerialHelper
      }
    }
  }, [_vm._v("\n                            Slik finner du serienummeret\n                        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSerialHelper),
      expression: "showSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Slik finner du serienummeret")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "max-height": "240px",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-beholder.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Lukk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.container.serial),
      expression: "$store.state.form.container.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.container.serial)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateSerial()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.container, "serial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mts"
  }, [(_vm.$store.state.form.validatedContainer !== null && _vm.$store.state.form.container.serial.length > 5) ? _c('span', {
    staticClass: "green"
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _c('span', [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length > 0) ? _c('span', {
    staticClass: "red"
  }, [_vm._v("\n                                    " + _vm._s(_vm.faucetSerial ? 'Det ser ut som om du er i ferd med å legge inn serienummeret til kranen, og ikke beholderen din. Vennligst tast inn serienummeret til beholderen din i dette feltet for å fortsette.' : 'Ingen treff funnet') + "\n                                ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(5), _vm._v("\n                        Du finner serienummeret på den sorte ledningen fra armaturet.\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = !_vm.showTapSerialHelper
      }
    }
  }, [_vm._v("Slik finner du serienummeret")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTapSerialHelper),
      expression: "showTapSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-hane.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.faucet.serial),
      expression: "$store.state.form.faucet.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.faucet.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.faucet, "serial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Serienummer på din CUBE\n                        ")]), _vm._v("\n                        Hvis du har en CUBE kjøleenhet. Finn serienummeret på klistremerket på fremsiden, rett nedenfor touch displayet.\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showCubeSerialHelper = !_vm.showCubeSerialHelper
      }
    }
  }, [_vm._v("Slik finner du serienummeret")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCubeSerialHelper),
      expression: "showCubeSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-cube.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showCubeSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.cube.serial),
      expression: "$store.state.form.cube.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.cube.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.cube, "serial", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }],
    staticClass: "step"
  }, [(_vm.showNordicChooser) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Twintaps eller single tap Nordic?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Twintaps består av både en kokende vannkran og et separat blandingsbatteri fra Quooker.\n                        Single tap er når du kun har en kokende vannkran fra Quooker.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Twintaps')
      }
    }
  }, [_vm._v("\n                            Twintaps\n                        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Single Tap')
      }
    }
  }, [_vm._v("\n                            Single tap\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbake\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.validatedFaucet === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 3
      }
    }
  }, [(_vm.$store.state.form.validatedFaucet === null) ? _c('span', [_vm._v("\n                            Kran må velges\n                        ")]) : _c('span', [_vm._v("\n                            Videre\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "faucets"
  }, _vm._l((_vm.sortedFaucets), function(faucet) {
    return _c('div', {
      key: faucet.title,
      staticClass: "faucet",
      class: {
        'selected': _vm.$store.state.form.validatedFaucet !== null && _vm.$store.state.form.validatedFaucet.title === faucet.title
      },
      on: {
        "click": function($event) {
          return _vm.validateFaucet(faucet)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": faucet.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(faucet.title) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n                            " + _vm._s(faucet.description) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 3),
      expression: "currentStep === 3"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbake\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.faucet.surface === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 4
      }
    }
  }, [(_vm.$store.state.form.faucet.surface === null) ? _c('span', [_vm._v("\n                            Overflate må velges\n                        ")]) : _c('span', [_vm._v("\n                            Videre\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "surfaces"
  }, _vm._l((_vm.sortedSurfaces), function(surface) {
    return _c('div', {
      key: surface.title,
      staticClass: "surface",
      class: {
        'selected': _vm.$store.state.form.faucet.surface === surface.title
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.faucet.surface = surface.title
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "sm",
      attrs: {
        "src": surface.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(surface.title) + "\n                        ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 4),
      expression: "currentStep === 4"
    }],
    staticClass: "step"
  }, [(_vm.showRestartHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Slik starter du Quooker på nytt\n                    ")]), _vm._v("\n                    Mange feil kan vellykkes, med en enkel omstart og tilbakestilling av Quooker-programvaren.\n                    "), _c('a', {
    attrs: {
      "href": "https://quooker.no/faq-generelt",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("\n                        Slik starter du Quooker på nytt")]), _vm._v(".\n                    "), _c('br'), _c('br'), _vm._v("\n                    Det er ikke nok bare å koble fra!\n                    "), _c('br'), _c('br'), _vm._v("\n                    Vi anbefaler at du prøver å starte Quooker på riktig måte noen ganger før du kontakter oss.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        Lukk vinduet\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.showBlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showBlinkHelper = false;
        _vm.$store.state.form.problem.questions[2].answer = null
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Hvordan blinker Quooker-kranen?\n                    ")]), _vm._v("\n                    Hvis din Quooker oppdager en feil/uregelmessighet vil lyset på kranen og beholderen blinke i et fast mønster.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "90%"
    }
  }, [_vm._v("OBS! I enkelte tilfelle er det kun beholderen som blinker, derfor er det viktig å sjekke både kranen og beholderen.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option-wrapper"
  }, [_c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '2 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '4 blink';
        _vm.showBlinkHelper = false;
        _vm.show4BlinkHelper = true
      }
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '3 + 1 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(10)])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "option last",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = 'Andet / ved ikke';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._v("\n                            Annet /vet ikke\n                        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.show4BlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "max-height": "90%",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        4 blink\n                    ")]), _vm._v("\n                    4 raske blink på kran eller beholder, betyr at softwaren i din Quooker registrerer en feil i forbindelse med temperaturmålingen i din Quooker.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#C80236"
    }
  }, [_vm._v("Tips!")]), _c('br'), _vm._v("\n                    Feilen kan ofte nullstilles, ved å gi beholderen et såkalt «kuldesjokk»."), _c('br'), _c('br'), _vm._v("\n                    Dette gjøres ved å slå av beholderen på beholderens topp, og tappe ut alt kokende vann i beholderen. Når vannet ikke lender er kokende, lar man vannet renne i ytterligere 2 minutter, slik at vi forsikrer oss om at vannet er helt kaldt."), _c('br'), _c('br'), _vm._v("\n                    Deretter skal du følge vår alminnelige "), _c('a', {
    staticClass: "main",
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "target": "_blank"
    }
  }, [_vm._v("restartsprosedyre")]), _vm._v(", og beholderen burde være klar til bruk etter ca. 20 minutter."), _c('br'), _c('br'), _vm._v("\n                    Det kan være nødvendig å gjenta denne prosedyren et par ganger."), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "unset",
      "outline": "none",
      "background": "#C80236",
      "color": "#fff",
      "border": "1px solid #e6003f!important",
      "padding": "5px 10px",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        OK, jeg prøver!\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 3
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbake\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.problem.questions[0].answer === null || _vm.$v.$store.state.form.problem.$invalid || _vm.$store.state.form.problem.questions[1].answer === null || _vm.$store.state.form.problem.questions[2].answer === null || _vm.$store.state.form.problem.description === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 5
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.$store.state.form.problem.questions), function(question, index) {
    return _c('div', {
      key: question.question,
      staticClass: "line",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('label', [_vm._v("\n                            " + _vm._s(question.questionNO) + "\n                        ")]), _vm._v(" "), (question.slug === 'restart') ? _c('div', [_vm._m(12, true)]) : _vm._e()]), _vm._v(" "), (index === 2) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true;
          _vm.showBlinkHelper = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.$store.state.form.problem.questions[index].extra = null
        }
      }
    }, [_vm._v("\n                            Nei\n                        ")])]) : (index === 3) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.showRestartHelper = true
        }
      }
    }, [_vm._v("\n                            Nei\n                        ")])]) : _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false
        }
      }
    }, [_vm._v("\n                            Nei\n                        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.problem.description),
      expression: "$store.state.form.problem.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Beskrivelse av problem",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.$store.state.form.problem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.problem, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper mts"
  }, [_c('validation-messages', {
    attrs: {
      "data": _vm.$v.$store.state.form.problem.description,
      "show": true
    }
  }), _vm._v(" "), (_vm.$store.state.form.problem.description) ? _c('div', {
    staticClass: "validator",
    class: {
      'validated': _vm.$store.state.form.problem.description.length > 19
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.problem.description.length) + " / 20\n                            ")]) : _vm._e()], 1)])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 5),
      expression: "currentStep === 5"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 4
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbake\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.warranty.underWarranty === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationMonth === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationYear === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 6
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === true
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = true
      }
    }
  }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === false
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = false
      }
    }
  }, [_vm._v("\n                            Nei\n                        ")])])]), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty === true) ? _c('div', {
    staticClass: "line"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationMonth),
      expression: "$store.state.form.warranty.installationMonth"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.months), function(month) {
    return _c('option', {
      key: month
    }, [_vm._v("\n                                " + _vm._s(month) + "\n                            ")])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationYear),
      expression: "$store.state.form.warranty.installationYear"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year
    }, [_vm._v("\n                                " + _vm._s(year) + "\n                            ")])
  }), 0)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 6),
      expression: "currentStep === 6"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 5
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 7
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('file-upload', {
    attrs: {
      "intro": "Valgfritt - Last opp bilder, video eller andre relevante filer hvis du har blitt bedt om det<br><br><b style='font-family:AvenirHeavyOblique;'>OBS</b>&nbsp;&nbsp;Hvis Quooker din har lyder, vil vi be om en video<br><b style='font-family:AvenirHeavyOblique;color:#fff;'>OBS</b>&nbsp;&nbsp;Hvis Quooker din har blitt fysisk skadet, ber vi om bilder",
      "singleFileUploaded": "fil lastet opp",
      "multipleFilesUploaded": "filer lastet opp",
      "noFilesUploaded": "Ingen filer lastet opp",
      "addFilesButton": "Legg til fil(er)",
      "remove": "Fjern"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 7),
      expression: "currentStep === 7"
    }],
    staticClass: "step"
  }, [(_vm.currentStep === 7) ? _c('div', {
    staticStyle: {
      "display": "none",
      "position": "absolute",
      "z-index": "999",
      "background": "#f8f9fc",
      "width": "100%"
    },
    attrs: {
      "id": "emailMockup"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "width": "400px",
      "margin": "25px auto"
    }
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.norwegian)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Viktig!")]), _vm._v(" Hvis du har spørsmål, vennligst besvar denne mail.\n                        "), _c('br'), _c('br'), _vm._v("\n                        Nedenfor finner du en kopi av dine inntastede opplysninger.\n                        "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "summary",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "border": "1px solid #ccc"
    }
  }, [_c('div', [_c('b', [_vm._v("Saksnummer")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.meta.id) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Beholder")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.container.serial !== null) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.container.serial.toUpperCase()) + " - " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.cube.serial !== null) ? _c('div', [_c('b', [_vm._v("CUBE")]), _vm._v(" "), _c('br'), _vm._v("\n                            Serienummer: " + _vm._s(_vm.$store.state.form.cube.serial) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.cube.serial !== null) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', [_c('b', [_vm._v("Kran")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.validatedFaucet.title) + "\n                            "), (_vm.$store.state.form.faucet.meta !== null) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.$store.state.form.faucet.meta) + ")\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.surface) + "\n                            ")]), _vm._v(" "), (_vm.$store.state.form.faucet.serial !== null) ? _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.serial) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Spørsmål")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.$store.state.form.problem.questions), function(q) {
    return _c('div', [_vm._v("\n                                " + _vm._s(q.questionNO) + ":\n                                "), (q.answer) ? _c('b', [_vm._v("\n                                    Ja\n                                ")]) : _c('b', [_vm._v("Nei")]), _vm._v(" "), (q.extra) ? _c('b', [_vm._v("\n                                    (" + _vm._s(q.extra) + ")\n                                ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Beskrivelse av problem")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.problem.description) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Garanti")]), _vm._v(" "), _c('br'), _vm._v("\n                            Er produktet under 24 måneder?\n                            "), (_vm.$store.state.form.warranty.underWarranty) ? _c('b', [_vm._v("Ja")]) : _c('b', [_vm._v("Nei")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty) ? _c('span', [_vm._v("\n                                Installasjonsdato:\n                                "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.warranty.installationMonth) + " " + _vm._s(_vm.$store.state.form.warranty.installationYear))])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Kontaktinformasjon")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.firstname) + "\n                            " + _vm._s(_vm.$store.state.form.contact.lastname) + "\n                            "), _c('br'), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('span', [_vm._v("\n                                Firma: " + _vm._s(_vm.$store.state.form.contact.company) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('br') : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.phone) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.email) + "\n                            "), _c('br'), _vm._v(" "), (_vm.fullAddress !== null) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm.fullAddress) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Vedlegg")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.attachments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.$store.state.form.attachments), function(attachment) {
    return _c('li', {
      key: attachment.name
    }, [_c('a', {
      attrs: {
        "href": attachment.path
      }
    }, [_vm._v("\n                                            " + _vm._s(attachment.name) + "\n                                        ")])])
  }), 0)]) : _c('div', [_vm._v("\n                                Ingen filer lastet opp\n                            ")])])]), _vm._v(" "), _vm._m(18)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 6
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbake\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.loading) ? _c('span', [_c('i', {
    staticClass: "fal fa-spinner fa-spin"
  }), _vm._v("\n                         \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.loading || _vm.$v.$store.state.form.contact.$invalid || _vm.$store.state.form.terms.accepted === false
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n                        Send\n                        "), _c('i', {
    staticClass: "fal fa-envelope"
  })])])]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line three-columns"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.firstname),
      expression: "$store.state.form.contact.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.firstname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left middle"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.lastname),
      expression: "$store.state.form.contact.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.lastname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Firma (valgfri)\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.company),
      expression: "$store.state.form.contact.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.email),
      expression: "$store.state.form.contact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.email
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.phone),
      expression: "$store.state.form.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.phone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line address-field"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "calc(100% + 30px)"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-sm-6"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "2f3b92h83nfuiei9he",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-sm-2"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipcode),
      expression: "zipcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-4"
  }, [_vm._m(26), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left fw terms"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.terms.accepted),
      expression: "$store.state.form.terms.accepted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.form.terms.accepted) ? _vm._i(_vm.$store.state.form.terms.accepted, null) > -1 : (_vm.$store.state.form.terms.accepted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$store.state.form.terms.accepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.form.terms, "accepted", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })])])]), _vm._v(" "), (_vm.currentStep === 8) ? _c('div', {
    staticClass: "step"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.norwegian)
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                Saksnummer: "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.meta.id))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Vi har sendt deg en e-post hvor saksnummeret ditt er notert. Hvis du ikke mottar denne e-post i løpet av en time, bør du sjekke om den har havnet som søppelpost. Hvis den heller ikke er der, ber vi deg kontakte oss på telefon.\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.currentStep !== 7) ? _c('div', {
    staticClass: "q-progress-bar"
  }, [_c('div', {
    staticClass: "line",
    style: ('width:' + ((16.66 * _vm.currentStep) - 16.66) + '%;')
  }), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 1
    }
  }, [_vm._v("\n            1\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 2
    }
  }, [_vm._v("\n            2\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 3
    }
  }, [_vm._v("\n            3\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 4
    }
  }, [_vm._v("\n            4\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 5
    }
  }, [_vm._v("\n            5\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 6
    }
  }, [_vm._v("\n            6\n        ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Kontaktskjema (Norge)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                         \n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                Kjære kunde,\n                "), _c('br'), _c('br'), _vm._v("\n                Dette kontaktskjemaet vedlikeholdes ikke lenger.\n                "), _c('br'), _c('br'), _vm._v("\n                Du finner nå all hjelp, veiledning og kontaktalternativer i selvbetjeningen vår.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#C80236",
      "font-family": "'AvenirHeavyOblique'"
    },
    attrs: {
      "href": "https://selvbetjening.quooker.no?utm_source=qservice&utm_medium=referral&utm_campaign=serviceform",
      "target": "_blank"
    }
  }, [_vm._v("Gå til selvbetjening →")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Angi serienummer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        1 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Serienummer på din beholder "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Serienummer på din kran "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Velg kran\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        2 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Velg overflate\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        3 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink two"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    2 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinktwo.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink four"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    4 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkfour.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink threeplusone"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    3 + 1 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkthreeplusone.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Problem / årsak\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        4 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quooker.no/faq-generelt",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle fa-fw"
  }), _vm._v("\n                                Slik tilbakestiller du din Quooker\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Beskriv problemet\n                        ")]), _vm._v("\n                        Beskriv problemet eller spørsmålet i feltet her. Ved feil er det viktig å forklare symptomet. Hva gjør du og hva skjer?\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Garanti\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        5 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Er produktet under 24 måneder?\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Installasjonsdato\n                        ")]), _vm._v("\n                        Velg måned og år for installasjon\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vedhæft filer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        6 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outro",
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _c('br'), _vm._v("\n                        Med vennlig hilsen\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Quooker Norge AS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Kontaktinformasjon\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        6 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Fornavn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Etternavn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            E-post "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Telefon "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Adresse "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Postnr. "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                By "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                            Jeg har lest og akseptert Quookers "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/privatlivspolitik",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("privatlivs- og forretningsbetingelser")]), _vm._v(" "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        INNSENDT - Takk for din henvendelse\n                    ")])])])
}]}

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(349),
  /* scopeId */
  "data-v-35b000a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[261]);


// WEBPACK FOOTER //
// static/js/app.7578dbd951a43f8b19ce.js